export enum Permissions {
  CanCreateAccountSettlements = 'CanCreateAccountSettlements',
  CanReviewAccountSettlements = 'CanReviewAccountSettlements',
  CanRequestAccountSettlementCancellation = 'CanRequestAccountSettlementCancellation',
  CanReviewAccountSettlementCancellation = 'CanReviewAccountSettlementCancellation',
  CanViewAccountSettlements = 'CanViewAccountSettlements',

  CanSendAdCampaigns = 'CanSendAdCampaigns',

  CanAssignAdvisorDepartments = 'CanAssignAdvisorDepartments',

  CanAssignAdvisorProjects = 'CanAssignAdvisorProjects',

  CanCreateBanks = 'CanCreateBanks',
  CanEditBanks = 'CanEditBanks',
  CanViewBanks = 'CanViewBanks',

  CanCreateBanners = 'CanCreateBanners',
  CanDeleteBanners = 'CanDeleteBanners',
  CanViewBanners = 'CanViewBanners',

  CanCreateCategories = 'CanCreateCategories',
  CanEditCategories = 'CanEditCategories',
  CanDeleteCategories = 'CanDeleteCategories',
  CanViewCategories = 'CanViewCategories',

  CanCreateCessionOfRights = 'CanCreateCessionOfRights',
  CanReviewCessionOfRights = 'CanReviewCessionOfRights',
  CanReviewCessionOfRightPayments = 'CanReviewCessionOfRightPayments',
  CanViewCessionOfRights = 'CanViewCessionOfRights',
  CanCreateCessionOfRightContractElaboration = 'CanCreateCessionOfRightContractElaboration',

  CanReviewChangeOfProducts = 'CanReviewChangeOfProducts',
  CanRequestChangeOfProducts = 'CanRequestChangeOfProducts',
  CanViewChangeOfProducts = 'CanViewChangeOfProducts',
  CanExecuteChangeOfProducts = 'CanExecuteChangeOfProducts',

  CanRequestChangeTotalToPaid = 'CanRequestChangeTotalToPaid',
  CanReviewChangeTotalToPaid = 'CanReviewChangeTotalToPaid',
  CanExecuteChangeTotalToPaid = 'CanExecuteChangeTotalToPaid',

  CanCreateCities = 'CanCreateCities',
  CanViewCities = 'CanViewCities',
  CanEditCities = 'CanEditCities',
  CanDeleteCities = 'CanDeleteCities',

  CanCreateCommissionTypes = 'CanCreateCommissionTypes',
  CanViewCommissionTypes = 'CanViewCommissionTypes',
  CanEditCommissionTypes = 'CanEditCommissionTypes',
  CanDeleteCommissionTypes = 'CanDeleteCommissionTypes',

  CanCreateCompanies = 'CanCreateCompanies',
  CanViewCompanies = 'CanViewCompanies',
  CanEditCompanies = 'CanEditCompanies',
  CanDeleteCompanies = 'CanDeleteCompanies',

  CanCreateCountries = 'CanCreateCountries',
  CanViewCountries = 'CanViewCountries',
  CanEditCountries = 'CanEditCountries',
  CanDeleteCountries = 'CanDeleteCountries',

  CanCreateCustomers = 'CanCreateCustomers',
  CanViewCustomers = 'CanViewCustomers',
  CanEditCustomers = 'CanEditCustomers',
  CanEditCustomersByExcel = 'CanEditCustomersByExcel',
  CanDeleteCustomers = 'CanDeleteCustomers',

  CanCreateDataSheets = 'CanCreateDataSheets',
  CanViewDataSheets = 'CanViewDataSheets',
  CanEditDataSheets = 'CanEditDataSheets',
  CanDeleteDataSheets = 'CanDeleteDataSheets',

  CanCreateDepartments = 'CanCreateDepartments',
  CanViewDepartments = 'CanViewDepartments',
  CanEditDepartments = 'CanEditDepartments',
  CanDeleteDepartments = 'CanDeleteDepartments',

  CanCreateDocumentTypes = 'CanCreateDocumentTypes',
  CanViewDocumentTypes = 'CanViewDocumentTypes',
  CanEditDocumentTypes = 'CanEditDocumentTypes',
  CanDeleteDocumentTypes = 'CanDeleteDocumentTypes',

  CanCreateHeroSliders = 'CanCreateHeroSliders',
  CanViewHeroSliders = 'CanViewHeroSliders',
  CanEditHeroSliders = 'CanEditHeroSliders',
  CanDeleteHeroSliders = 'CanDeleteHeroSliders',

  CanCreateInterestLevels = 'CanCreateInterestLevels',
  CanViewInterestLevels = 'CanViewInterestLevels',
  CanEditInterestLevels = 'CanEditInterestLevels',
  CanDeleteInterestLevels = 'CanDeleteInterestLevels',

  CanCreateMessages = 'CanCreateMessages',
  CanViewMessages = 'CanViewMessages',

  CanCreateOpportunities = 'CanCreateOpportunities',
  CanViewOpportunities = 'CanViewOpportunities',
  CanEditOpportunities = 'CanEditOpportunities',
  CanDeleteOpportunities = 'CanDeleteOpportunities',
  CanManageOpportunityActivities = 'CanManageOpportunityActivities',
  CanCommentOpportunities = 'CanCommentOpportunities',
  CanDeleteOpportunityComments = 'CanDeleteOpportunityComments',
  CanManageOpportunityDocuments = 'CanManageOpportunityDocuments',
  CanChangeOpportunitySaleAdvisors = 'CanChangeOpportunitySaleAdvisors',

  CanCreateOpportunitySteps = 'CanCreateOpportunitySteps',
  CanViewOpportunitySteps = 'CanViewOpportunitySteps',
  CanEditOpportunitySteps = 'CanEditOpportunitySteps',
  CanDeleteOpportunitySteps = 'CanDeleteOpportunitySteps',

  CanCreatePaymentAccounts = 'CanCreatePaymentAccounts',
  CanViewPaymentAccounts = 'CanViewPaymentAccounts',
  CanEditPaymentAccounts = 'CanEditPaymentAccounts',
  CanDeletePaymentAccounts = 'CanDeletePaymentAccounts',

  CanRequestPaymentCommissions = 'CanRequestPaymentCommissions',
  CanReviewPaymentCommissions = 'CanReviewPaymentCommissions',
  CanApplyPaymentCommissions = 'CanApplyPaymentCommissions',
  CanViewPaymentCommissions = 'CanViewPaymentCommissions',
  CanImportPaymentCommissions = 'CanImportPaymentCommissions',

  CanCreatePaymentOrders = 'CanCreatePaymentOrders',
  CanChangePaymentOrderPeriod = 'CanChangePaymentOrderPeriod',
  CanViewPaymentOrders = 'CanViewPaymentOrders',
  CanAdjustPaymentOrderPaymentDates = 'CanAdjustPaymentOrderPaymentDates',
  CanRequestPaymentOrderPenalties = 'CanRequestPaymentOrderPenalties',
  CanReviewPaymentOrderPenalties = 'CanReviewPaymentOrderPenalties',
  CanRequestPaymentOrderWithdrawals = 'CanRequestPaymentOrderWithdrawals',
  CanReviewPaymentOrderWithdrawals = 'CanReviewPaymentOrderWithdrawals',
  CanSendPaymentReceipts = 'CanSendPaymentReceipts',
  CanSendPaymentReminders = 'CanSendPaymentReminders',
  CanSendAccountStatuses = 'CanSendAccountStatuses',
  CanSetCustomFees = 'CanSetCustomFees',
  CanSetTaxRateReserves = 'CanSetTaxRateReserves',
  CanRequestWithdrawalBankChecks = 'CanRequestWithdrawalBankChecks',
  CanAddWithdrawalChecks = 'CanAddWithdrawalChecks',
  CanEditPaymentOrders = 'CanEditPaymentOrders',
  CanEditPaymentOrderPremium = 'CanEditPaymentOrderPremium',
  CanUpdatePaymentBalances = 'CanUpdatePaymentBalances',

  CanReviewAccountingPaymentCommissions = 'CanReviewAccountingPaymentCommissions',
  CanCancelRequestPaymentCommissions = 'CanCancelRequestPaymentCommissions',
  CanApprovePaymentOrder = 'CanApprovePaymentOrder',

  CanRequestPayments = 'CanRequestPayments',
  CanReviewPaymentRequests = 'CanReviewPaymentRequests',
  CanCreatePayments = 'CanCreatePayments',
  CanRequestPaymentModifications = 'CanRequestPaymentModifications',
  CanReviewPaymentModifications = 'CanReviewPaymentModifications',
  CanCreateExtraordinaryPayments = 'CanCreateExtraordinaryPayments',
  CanRequestMovePayments = 'CanRequestMovePayments',
  CanReviewMovePayments = 'CanReviewMovePayments',
  CanEditPayments = 'CanEditPayments',
  CanRequestPaymentCancellations = 'CanRequestPaymentCancellations',
  CanReviewPaymentCancellations = 'CanReviewPaymentCancellations',
  CanCancelPayments = 'CanCancelPayments',
  CanMovePaymentToReservation = 'CanMovePaymentToReservation',
  CanRevertPaymentChanges = 'CanRevertPaymentChanges',
  CanViewPaymentRequests = 'CanViewPaymentRequests',
  CanReciveEmailPaymentRequest = 'CanReciveEmailPaymentRequest',

  CanCreateProducts = 'CanCreateProducts',
  CanViewProducts = 'CanViewProducts',
  CanEditProducts = 'CanEditProducts',
  CanDeleteProducts = 'CanDeleteProducts',
  CanChangeProductSalePrices = 'CanChangeProductSalePrices',
  CanEditProductDataSheets = 'CanEditProductDataSheets',
  CanEditProductImages = 'CanEditProductImages',

  CanCreateProductReserves = 'CanCreateProductReserves',
  CanRequestProductReserveChanges = 'CanRequestProductReserveChanges',
  CanReviewProductReserveChanges = 'CanReviewProductReserveChanges',
  CanChangeProductReserveTotals = 'CanChangeProductReserveTotals',
  CanRevertProductReserveChanges = 'CanRevertProductReserveChanges',

  CanCreatePaymentReserve = 'CanCreatePaymentReserve',
  CanEditPaymentReserve = 'CanEditPaymentReserve',
  CanRequestPaymentReserveChanges = 'CanRequestPaymentReserveChanges',
  CanReviewPaymentReserveChanges = 'CanReviewPaymentReserveChanges',
  CanCancelPaymentReserve = 'CanCancelPaymentReserve',
  CanRequestPaymentReserveCancellations = 'CanRequestPaymentReserveCancellations',
  CanReviewPaymentReserveCancellations = 'CanReviewPaymentReserveCancellations',
  CanRevertPaymentReserveChanges = 'CanRevertPaymentReserveChanges',

  CanCreateProjects = 'CanCreateProjects',
  CanViewProjects = 'CanViewProjects',
  CanEditProjects = 'CanEditProjects',
  CanDeleteProjects = 'CanDeleteProjects',

  CanCreateProjectCommissions = 'CanCreateProjectCommissions',
  CanViewProjectCommissions = 'CanViewProjectCommissions',
  CanEditProjectCommissions = 'CanEditProjectCommissions',
  CanDeleteProjectCommissions = 'CanDeleteProjectCommissions',

  CanCreateProspects = 'CanCreateProspects',
  CanViewProspects = 'CanViewProspects',
  CanEditProspects = 'CanEditProspects',
  CanViewUnqualifiedProspects = 'CanViewUnqualifiedProspects',
  CanConvertProspects = 'CanConvertProspects',
  CanManageProspectActivities = 'CanManageProspectActivities',

  CanCreateQuotations = 'CanCreateQuotations',
  CanViewQuotations = 'CanViewQuotations',
  CanEditQuotations = 'CanEditQuotations',
  CanCancelQuotations = 'CanCancelQuotations',
  CanRequestQuotationCancellations = 'CanRequestQuotationCancellations',
  CanReviewQuotationCancellations = 'CanReviewQuotationCancellations',
  CanRemoveQuotationProducts = 'CanRemoveQuotationProducts',
  CanApproveDiscountQuatations = 'CanApproveDiscountQuatations',

  CanCreateReasonsForRequest = 'CanCreateReasonsForRequest',
  CanViewReasonsForRequest = 'CanViewReasonsForRequest',
  CanEditReasonsForRequest = 'CanEditReasonsForRequest',
  CanDeleteReasonsForRequest = 'CanDeleteReasonsForRequest',

  CanCreateRoles = 'CanCreateRoles',
  CanViewRoles = 'CanViewRoles',
  CanEditRoles = 'CanEditRoles',
  CanDeleteRoles = 'CanDeleteRoles',

  CanCreateStatuses = 'CanCreateStatuses',
  CanViewStatuses = 'CanViewStatuses',
  CanEditStatuses = 'CanEditStatuses',
  CanDeleteStatuses = 'CanDeleteStatuses',

  CanCreateSubcategories = 'CanCreateSubcategories',
  CanViewSubcategories = 'CanViewSubcategories',
  CanEditSubcategories = 'CanEditSubcategories',
  CanDeleteSubcategories = 'CanDeleteSubcategories',

  CanCreateTypeActivities = 'CanCreateTypeActivities',
  CanViewTypeActivities = 'CanViewTypeActivities',
  CanEditTypeActivities = 'CanEditTypeActivities',
  CanDeleteTypeActivities = 'CanDeleteTypeActivities',


  CanCreateEvaluations = 'CanCreateEvaluations',
  CanViewEvaluations = 'CanViewEvaluations',
  CanEditEvaluations = 'CanEditEvaluations',
  CanCloseEvaluations = 'CanCloseEvaluations',
  CanApproveEscalatedEvaluations = 'CanApproveEscalatedEvaluations',

  CanCreateEvaluationReasons = 'CanCreateEvaluationReasons',
  CanViewEvaluationReasons = 'CanViewEvaluationReasons',
  CanEditEvaluationReasons = 'CanEditEvaluationReasons',
  CanDeleteEvaluationReasons = 'CanDeleteEvaluationReasons',

  CanCreatePepTypes = 'CanCreatePepTypes',
  CanViewPepTypes = 'CanViewPepTypes',
  CanEditPepTypes = 'CanEditPepTypes',
  CanDeletePepTypes = 'CanDeletePepTypes',

  CanCreateTypeOrigins = 'CanCreateTypeOrigins',
  CanViewTypeOrigins = 'CanViewTypeOrigins',
  CanEditTypeOrigins = 'CanEditTypeOrigins',
  CanDeleteTypeOrigins = 'CanDeleteTypeOrigins',

  CanCreateTypeStatuses = 'CanCreateTypeStatuses',
  CanViewTypeStatuses = 'CanViewTypeStatuses',
  CanEditTypeStatuses = 'CanEditTypeStatuses',
  CanDeleteTypeStatuses = 'CanDeleteTypeStatuses',

  CanCreateUnitOfMeasurements = 'CanCreateUnitOfMeasurements',
  CanViewUnitOfMeasurements = 'CanViewUnitOfMeasurements',
  CanEditUnitOfMeasurements = 'CanEditUnitOfMeasurements',
  CanDeleteUnitOfMeasurements = 'CanDeleteUnitOfMeasurements',

  CanCreateUsers = 'CanCreateUsers',
  CanViewUsers = 'CanViewUsers',
  CanEditUsers = 'CanEditUsers',
  CanDeleteUsers = 'CanDeleteUsers',
  CanCreateUserBrokers = 'CanCreateUserBrokers',

  CanCreateUserCommissions = 'CanCreateUserCommissions',
  CanRemoveUserCommissions = 'CanRemoveUserCommissions',
  CanCancelProductCommissions = 'CanCancelProductCommissions',
  CanEditUserCommissions = 'CanEditUserCommissions',
  CanViewUserCommissions = 'CanViewUserCommissions',

  CanCreateWinReasons = 'CanCreateWinReasons',
  CanViewWinReasons = 'CanViewWinReasons',
  CanEditWinReasons = 'CanEditWinReasons',
  CanDeleteWinReasons = 'CanDeleteWinReasons',

  CanCreateLossReasons = 'CanCreateLossReasons',
  CanViewLossReasons = 'CanViewLossReasons',
  CanEditLossReasons = 'CanEditLossReasons',
  CanDeleteLossReasons = 'CanDeleteLossReasons',

  CanViewBreakEvenPointKpi = 'CanViewBreakEvenPointKpi',
  CanViewPendingPremiumAmountReceivableSummaryKpi = 'CanViewPendingPremiumAmountReceivableSummaryKpi',
  CanViewProjectAreaSummaryKpi = 'CanViewProjectAreaSummaryKpi',
  CanViewProjectAreaSalePriceSummaryKpi = 'CanViewProjectAreaSalePriceSummaryKpi',
  CanViewProjectIncomeSummaryKpi = 'CanViewProjectIncomeSummaryKpi',
  CanViewProjectReservedIncomeSummaryKpi = 'CanViewProjectReservedIncomeSummaryKpi',
  CanViewProjectSubcategoriesSummaryKpi = 'CanViewProjectSubcategoriesSummaryKpi',
  CanViewTotalCommissionKpis = 'CanViewTotalCommissionKpis',
  CanViewAdvisorKpis = 'CanViewAdvisorKpis',
  CanViewOpportunitiesKpis = 'CanViewOpportunitiesKpis',
  CanViewSalesPerMonthKpi = 'CanViewSalesPerMonthKpi',
  CanViewLeadsKpis = 'CanViewLeadsKpis',
  CanViewMarketingDashboard = 'CanViewMarketingDashboard',
  CanViewGeneralLeadsReport = 'CanViewGeneralLeadsReport',
  CanViewProductStatusKpis = 'CanViewProductStatusKpis',
  CanViewTotalComparativeKpis = 'CanViewTotalComparativeKpis',
  CanViewPaymentRequestKpi = 'CanViewPaymentRequestKpi',
  CanViewClientsPerProjectKpi = 'CanViewClientsPerProjectKpi',
  CanViewAdvisorGoalKpi = 'CanViewAdvisorGoalKpi',
  CanViewAllKpis = 'CanViewAllKpis',

  CanViewTopQuoteProductReport = 'CanViewTopQuoteProductReport',
  CanViewProductsByProjectReport = 'CanViewProductsByProjectReport',
  CanViewAvailableProductsReport = 'CanViewAvailableProductsReport',
  CanViewTopSoldProductReport = 'CanViewTopSoldProductReport',
  CanViewAdvisorActivitiesReport = 'CanViewAdvisorActivitiesReport',
  CanViewOpportunityOriginsReport = 'CanViewOpportunityOriginsReport',
  CanViewPaymentHistoryReport = 'CanViewPaymentHistoryReport',
  CanViewPaymentReservesHistoryReport = 'CanViewPaymentReservesHistoryReport',
  CanViewMasterOpportunityReport = 'CanViewMasterOpportunityReport',
  CanViewMasterProspectReport = 'CanViewMasterProspectReport',
  CanViewAdvisorGoalReport = 'CanViewAdvisorGoalReport',
  CanViewClientQuoteReport = 'CanViewClientQuoteReport',
  CanViewClientByProductReport = 'CanViewClientByProductReport',
  CanViewUnificatePaymentOrderReport = 'CanViewUnificatePaymentOrderReport',
  CanViewCustomerWalletReport = 'CanViewCustomerWalletReport',
  CanViewAdvisorPaymentStatusReport = 'CanViewAdvisorPaymentStatusReport',
  CanViewCustomerPaymentStatusReport = 'CanViewCustomerPaymentStatusReport',
  CanViewOldBalancesReport = 'CanViewOldBalancesReport',
  CanViewPendingWithdrawalReport = 'CanViewPendingWithdrawalReport',
  CanViewWithdrawalRequestsApprovedReport = 'CanViewWithdrawalRequestsApprovedReport',
  CanViewPaidCommissionPerMonthReport = 'CanViewPaidCommissionPerMonthReport',
  CanViewPendingPaymentCommissionReport = 'CanViewPendingPaymentCommissionReport',
  CanViewCommissionsPerProjectReport = 'CanViewCommissionsPerProjectReport',
  CanViewCustomerInfoReport = 'CanViewCustomerInfoReport',
  CanViewCustomersHistoryReport = 'CanViewCustomersHistoryReport',
  CanViewDocumentationComplianceReport = 'CanViewDocumentationComplianceReport',
  CanViewAccountsReceivableReport = 'CanViewAccountsReceivableReport',
  CanViewCommissionsAvailableForPaymentReport = 'CanViewCommissionsAvailableForPaymentReport',
  CanViewPendingPremiumAmountReceivableReport = 'CanViewPendingPremiumAmountReceivableReport',
  CanViewProjectTotalReservedIncomeDetailReport = 'CanViewProjectTotalReservedIncomeDetailReport',
  CanViewProjectTotalReservedIncomePaymentDetailReport = 'CanViewProjectTotalReservedIncomePaymentDetailReport',
  CanViewProductReservesDetailReport = 'CanViewProductReservesDetailReport',
  CanViewPaymentOrdersFeesDetailReport = 'CanViewPaymentOrdersFeesDetailReport',
  CanViewProductDatasheetReport = 'CanViewProductDatasheetReport',
  CanViewAllReports = 'CanViewAllReports',

  CanExecuteJobs = 'CanExecuteJobs',

  CanCreateDiscardReasons = 'CanCreateDiscardReasons',
  CanViewDiscardReasons = 'CanViewDiscardReasons',
  CanEditDiscardReasons = 'CanEditDiscardReasons',
  CanDeleteDiscardReasons = 'CanDeleteDiscardReasons',

  CanCreateProspectActivity = 'CanCreateProspectActivity',
  CanViewProspectActivity = 'CanViewProspectActivity',
  CanEditProspectActivity = 'CanEditProspectActivity',
  CanDeleteProspectActivity = 'CanDeleteProspectActivity',

  CanCreatePaymentOrderActivity = 'CanCreatePaymentOrderActivity',
  CanViewPaymentOrderActivity = 'CanViewPaymentOrderActivity',
  CanEditPaymentOrderActivity = 'CanEditPaymentOrderActivity',
  CanDeletePaymentOrderActivity = 'CanDeletePaymentOrderActivity',

  CanCreateTypeActivityModule = 'CanCreateTypeActivityModule',
  CanViewTypeActivityModule = 'CanViewTypeActivityModule',
  CanEditTypeActivityModule = 'CanEditTypeActivityModule',
  CanDeleteTypeActivityModule = 'CanDeleteTypeActivityModule',

  CanCreateTypeDocumentModule = 'CanCreateTypeDocumentModule',
  CanViewTypeDocumentModule = 'CanViewTypeDocumentModule',
  CanEditTypeDocumentModule = 'CanEditTypeDocumentModule',
  CanDeleteTypeDocumentModule = 'CanDeleteTypeDocumentModule',

  CanChangeApplyProductCommission = 'CanChangeApplyProductCommission',
  CanReciveEmailCreateCommission = 'CanReciveEmailCreateCommission',
  CanReciveEmailPendingReviewCommission = 'CanReciveEmailPendingReviewCommission',
  CanReciveEmailPendingReviewAccountingCommission = 'CanReciveEmailPendingReviewAccountingCommission',
  CanReciveEmailSignatureSaleAdvisorCommission = 'CanReciveEmailSignatureSaleAdvisorCommission',
  CanReciveEmailSignatureSaleAdvisorApproveCommission = 'CanReciveEmailSignatureSaleAdvisorApproveCommission',
  CanReciveEmailCheckAccountingCommission = 'CanReciveEmailCheckAccountingCommission',
  CanReciveEmailApplyPaymentAccountingCommission = 'CanReciveEmailApplyPaymentAccountingCommission',

  CanRequestPenaltyPaymentCommissions = 'CanRequestPenaltyPaymentCommissions',
  CanReceiveEmailPenaltyCommission = 'CanReceiveEmailPenaltyCommission',
  CanViewRequestPenaltyPaymentCommissions = 'CanViewRequestPenaltyPaymentCommissions',
  CanCancelRequestPenaltyPaymentCommissions = 'CanCancelRequestPenaltyPaymentCommissions',
  CanApproveRequestPenaltyPaymentCommissions = 'CanApproveRequestPenaltyPaymentCommissions',

  CanCreateAdvisorGroup = 'CanCreateAdvisorGroup',
  CanViewAdvisorGroup = 'CanViewAdvisorGroup',
  CanEditAdvisorGroup = 'CanEditAdvisorGroup',
  CanDeleteAdvisorGroup = 'CanDeleteAdvisorGroup',

  CanViewGoalKpi = 'CanViewGoalKpi',
  CanCreateGoal = 'CanCreateGoal',
  CanViewGoal = 'CanViewGoal',
  CanEditGoal = 'CanEditGoal',
  CanDeleteGoal = 'CanDeleteGoal',
  CanCreateGoalMetric = 'CanCreateGoalMetric',
  CanViewGoalMetric = 'CanViewGoalMetric',
  CanEditGoalMetric = 'CanEditGoalMetric',
  CanDeleteGoalMetric = 'CanDeleteGoalMetric',

  CanCreateNotifications = 'CanCreateNotifications',
  CanViewNotifications = 'CanViewNotifications',
  CanEditNotifications = 'CanEditNotifications',
  CanDeleteNotifications = 'CanDeleteNotifications',

  CanCreateProductDeliveries = 'CanCreateProductDeliveries',
  CanViewProductDeliveries = 'CanViewProductDeliveries',
  CanReviewProductDeliveryFinancingProcesses = 'CanReviewProductDeliveryFinancingProcesses',
  CanReviewProductDeliveryLegalProcess = 'CanReviewProductDeliveryLegalProcess',
  CanManageProductDeliveryProtocolSign = 'CanManageProductDeliveryProtocolSign',
  CanManageProductDeliveryDisbursements = 'CanManageProductDeliveryDisbursements',
  CanCancelProductDeliveries = 'CanCancelProductDeliveries',
  CanManageProductDeliveryDocuments = 'CanManageProductDeliveryDocuments',
  CanMoveProductDeliveriesThroughTransitionalSteps = 'CanMoveProductDeliveriesThroughTransitionalSteps',

  CanCreateProspectStatus = 'CanCreateProspectStatus',
  CanViewProspectStatus = 'CanViewProspectStatus',
  CanEditProspectStatus = 'CanEditProspectStatus',
  CanDeleteProspectStatus = 'CanDeleteProspectStatus',
  CanCreateProspectStepStatus = 'CanCreateProspectStepStatus',
  CanViewProspectStepStatus = 'CanViewProspectStepStatus',
  CanUpdateProspectStepStatus = 'CanUpdateProspectStepStatus',
  CanModifyFinalizedProductDeliveries = 'CanModifyFinalizedProductDeliveries',
  CanEditProductInspection = 'CanEditProductInspection',

  CanRequestOverdueCondone = 'CanRequestOverdueCondone',
  CanApproveOverdueCondone = 'CanApproveOverdueCondone',
  CanApplyPaymentOrderDiscount = 'CanApplyPaymentOrderDiscount',
  CanApprovePaymentOrderDiscount = 'CanApprovePaymentOrderDiscount',
  CanAdditionalPaymentOrderFee = 'CanAdditionalPaymentOrderFee',
  CanSyncPaymentOrderInvoice = 'CanSyncPaymentOrderInvoice',

  CanCreateDiscountTypes = 'CanCreateDiscountTypes',
  CanEditDiscountTypes = 'CanEditDiscountTypes',
  CanViewDiscountTypes = 'CanViewDiscountTypes',
  CanDeleteDiscountTypes = 'CanDeleteDiscountTypes',
  
  CanViewExchangeRates = 'CanViewExchangeRates',
  CanCreateExchangeRates = 'CanCreateExchangeRates',
  CanEditExchangeRates = 'CanEditExchangeRates',
  CanRunExchangeRateSync = 'CanRunExchangeRateSync',

  CanViewOpportunityStepTransitionTimeReport = 'CanViewOpportunityStepTransitionTimeReport',

  CanConfigureOpportunityStageGoals = 'CanConfigureOpportunityStageGoals',

  CanEditOpportunityStageGoalTargets = 'CanEditOpportunityStageGoalTargets',

  CanViewOwnGoalCommissions = 'CanViewOwnGoalCommissions',
  CanViewGoalCommissions = 'CanViewGoalCommissions',
  CanReviewGoalCommissionItems = 'CanReviewGoalCommissionItems',
  CanProposeGoalCommissionPayments = 'CanProposeGoalCommissionPayments',
  CanApproveGoalCommissionRequests = 'CanApproveGoalCommissionRequests',
  CanResolveGoalCommissionIncidents = 'CanResolveGoalCommissionIncidents',
  CanManageGoalCommissionSettings = 'CanManageGoalCommissionSettings',
}

export interface Permission {
  permissionId: number
  permissionSelector: string
  permissions: string[]
}

interface CheckPermissionUser {
  fullName: string
  id: string
  permissions: Permissions[]
}

interface HasPermissionParams {
  user: CheckPermissionUser
}

interface PermissionDefinition<T = {}> {
  permissionId: number
  permissionSelector: string
  permissions: Permissions[]
  hasPermission: (params: HasPermissionParams & T) => boolean
}

export interface PermissionMap {
  CanCreateAccountSettlements: PermissionDefinition<{}>
  CanReviewAccountSettlements: PermissionDefinition<{}>
  CanRequestAccountSettlementCancellation: PermissionDefinition<{}>
  CanReviewAccountSettlementCancellation: PermissionDefinition<{}>
  CanViewAccountSettlements: PermissionDefinition<{}>

  CanSendAdCampaigns: PermissionDefinition<{}>

  CanAssignAdvisorDepartments: PermissionDefinition<{}>

  CanAssignAdvisorProjects: PermissionDefinition<{}>

  CanCreateBanks: PermissionDefinition<{}>
  CanEditBanks: PermissionDefinition<{}>
  CanViewBanks: PermissionDefinition<{}>

  CanCreateBanners: PermissionDefinition<{}>
  CanDeleteBanners: PermissionDefinition<{}>
  CanViewBanners: PermissionDefinition<{}>

  CanCreateCategories: PermissionDefinition<{}>
  CanEditCategories: PermissionDefinition<{}>
  CanDeleteCategories: PermissionDefinition<{}>
  CanViewCategories: PermissionDefinition<{}>

  CanCreateCessionOfRights: PermissionDefinition<{}>
  CanReviewCessionOfRights: PermissionDefinition<{}>
  CanReviewCessionOfRightPayments: PermissionDefinition<{}>
  CanViewCessionOfRights: PermissionDefinition<{}>
  CanCreateCessionOfRightContractElaboration: PermissionDefinition<{}>

  CanReviewChangeOfProducts: PermissionDefinition<{}>
  CanRequestChangeOfProducts: PermissionDefinition<{}>
  CanViewChangeOfProducts: PermissionDefinition<{}>
  CanExecuteChangeOfProducts: PermissionDefinition<{}>

  CanRequestChangeTotalToPaid: PermissionDefinition<{}>
  CanReviewChangeTotalToPaid: PermissionDefinition<{}>
  CanExecuteChangeTotalToPaid: PermissionDefinition<{}>

  CanCreateCities: PermissionDefinition<{}>
  CanViewCities: PermissionDefinition<{}>
  CanEditCities: PermissionDefinition<{}>
  CanDeleteCities: PermissionDefinition<{}>

  CanCreateCommissionTypes: PermissionDefinition<{}>
  CanViewCommissionTypes: PermissionDefinition<{}>
  CanEditCommissionTypes: PermissionDefinition<{}>
  CanDeleteCommissionTypes: PermissionDefinition<{}>

  CanCreateCompanies: PermissionDefinition<{}>
  CanViewCompanies: PermissionDefinition<{}>
  CanEditCompanies: PermissionDefinition<{}>
  CanDeleteCompanies: PermissionDefinition<{}>

  CanCreateCountries: PermissionDefinition<{}>
  CanViewCountries: PermissionDefinition<{}>
  CanEditCountries: PermissionDefinition<{}>
  CanDeleteCountries: PermissionDefinition<{}>

  CanCreateCustomers: PermissionDefinition<{}>
  CanViewCustomers: PermissionDefinition<{}>
  CanEditCustomers: PermissionDefinition<{}>
  CanEditCustomersByExcel: PermissionDefinition<{}>
  CanDeleteCustomers: PermissionDefinition<{}>

  CanCreateDataSheets: PermissionDefinition<{}>
  CanViewDataSheets: PermissionDefinition<{}>
  CanEditDataSheets: PermissionDefinition<{}>
  CanDeleteDataSheets: PermissionDefinition<{}>

  CanCreateDepartments: PermissionDefinition<{}>
  CanViewDepartments: PermissionDefinition<{}>
  CanEditDepartments: PermissionDefinition<{}>
  CanDeleteDepartments: PermissionDefinition<{}>

  CanCreateDocumentTypes: PermissionDefinition<{}>
  CanViewDocumentTypes: PermissionDefinition<{}>
  CanEditDocumentTypes: PermissionDefinition<{}>
  CanDeleteDocumentTypes: PermissionDefinition<{}>

  CanCreateHeroSliders: PermissionDefinition<{}>
  CanViewHeroSliders: PermissionDefinition<{}>
  CanEditHeroSliders: PermissionDefinition<{}>
  CanDeleteHeroSliders: PermissionDefinition<{}>

  CanCreateInterestLevels: PermissionDefinition<{}>
  CanViewInterestLevels: PermissionDefinition<{}>
  CanEditInterestLevels: PermissionDefinition<{}>
  CanDeleteInterestLevels: PermissionDefinition<{}>

  CanCreateMessages: PermissionDefinition<{}>
  CanViewMessages: PermissionDefinition<{}>

  CanCreateOpportunities: PermissionDefinition<{}>
  CanViewOpportunities: PermissionDefinition<{}>
  CanEditOpportunities: PermissionDefinition<{}>
  CanDeleteOpportunities: PermissionDefinition<{}>
  CanManageOpportunityActivities: PermissionDefinition<{}>
  CanCommentOpportunities: PermissionDefinition<{}>
  CanDeleteOpportunityComments: PermissionDefinition<{}>
  CanManageOpportunityDocuments: PermissionDefinition<{}>
  CanChangeOpportunitySaleAdvisors: PermissionDefinition<{}>

  CanCreateOpportunitySteps: PermissionDefinition<{}>
  CanViewOpportunitySteps: PermissionDefinition<{}>
  CanEditOpportunitySteps: PermissionDefinition<{}>
  CanDeleteOpportunitySteps: PermissionDefinition<{}>

  CanCreatePaymentAccounts: PermissionDefinition<{}>
  CanViewPaymentAccounts: PermissionDefinition<{}>
  CanEditPaymentAccounts: PermissionDefinition<{}>
  CanDeletePaymentAccounts: PermissionDefinition<{}>

  CanRequestPaymentCommissions: PermissionDefinition<{}>
  CanReviewPaymentCommissions: PermissionDefinition<{}>
  CanApplyPaymentCommissions: PermissionDefinition<{}>
  CanViewPaymentCommissions: PermissionDefinition<{}>
  CanImportPaymentCommissions: PermissionDefinition<{}>

  CanCreatePaymentOrders: PermissionDefinition<{}>
  CanChangePaymentOrderPeriod: PermissionDefinition<{}>
  CanViewPaymentOrders: PermissionDefinition<{}>
  CanAdjustPaymentOrderPaymentDates: PermissionDefinition<{}>
  CanRequestPaymentOrderPenalties: PermissionDefinition<{}>
  CanReviewPaymentOrderPenalties: PermissionDefinition<{}>
  CanRequestPaymentOrderWithdrawals: PermissionDefinition<{}>
  CanReviewPaymentOrderWithdrawals: PermissionDefinition<{}>
  CanSendPaymentReceipts: PermissionDefinition<{}>
  CanSendPaymentReminders: PermissionDefinition<{}>
  CanSendAccountStatuses: PermissionDefinition<{}>
  CanSetCustomFees: PermissionDefinition<{}>
  CanSetTaxRateReserves: PermissionDefinition<{}>
  CanRequestWithdrawalBankChecks: PermissionDefinition<{}>
  CanAddWithdrawalChecks: PermissionDefinition<{}>
  CanEditPaymentOrders: PermissionDefinition<{}>
  CanEditPaymentOrderPremium: PermissionDefinition<{}>
  CanUpdatePaymentBalances: PermissionDefinition<{}>

  CanReviewAccountingPaymentCommissions: PermissionDefinition<{}>
  CanCancelRequestPaymentCommissions: PermissionDefinition<{}>
  CanApprovePaymentOrder: PermissionDefinition<{}>

  CanRequestPayments: PermissionDefinition<{}>
  CanReviewPaymentRequests: PermissionDefinition<{}>
  CanCreatePayments: PermissionDefinition<{}>
  CanRequestPaymentModifications: PermissionDefinition<{}>
  CanReviewPaymentModifications: PermissionDefinition<{}>
  CanCreateExtraordinaryPayments: PermissionDefinition<{}>
  CanRequestMovePayments: PermissionDefinition<{}>
  CanReviewMovePayments: PermissionDefinition<{}>
  CanEditPayments: PermissionDefinition<{}>
  CanRequestPaymentCancellations: PermissionDefinition<{}>
  CanReviewPaymentCancellations: PermissionDefinition<{}>
  CanCancelPayments: PermissionDefinition<{}>
  CanMovePaymentToReservation: PermissionDefinition<{}>
  CanRevertPaymentChanges: PermissionDefinition<{}>
  CanViewPaymentRequests: PermissionDefinition<{}>
  CanReciveEmailPaymentRequest: PermissionDefinition<{}>

  CanCreateProducts: PermissionDefinition<{}>
  CanViewProducts: PermissionDefinition<{}>
  CanEditProducts: PermissionDefinition<{}>
  CanDeleteProducts: PermissionDefinition<{}>
  CanChangeProductSalePrices: PermissionDefinition<{}>
  CanEditProductDataSheets: PermissionDefinition<{}>
  CanEditProductImages: PermissionDefinition<{}>

  CanCreateProductReserves: PermissionDefinition<{}>
  CanRequestProductReserveChanges: PermissionDefinition<{}>
  CanReviewProductReserveChanges: PermissionDefinition<{}>
  CanChangeProductReserveTotals: PermissionDefinition<{}>
  CanRevertProductReserveChanges: PermissionDefinition<{}>

  CanCreatePaymentReserve: PermissionDefinition<{}>
  CanEditPaymentReserve: PermissionDefinition<{}>
  CanRequestPaymentReserveChanges: PermissionDefinition<{}>
  CanReviewPaymentReserveChanges: PermissionDefinition<{}>
  CanCancelPaymentReserve: PermissionDefinition<{}>
  CanRequestPaymentReserveCancellations: PermissionDefinition<{}>
  CanReviewPaymentReserveCancellations: PermissionDefinition<{}>
  CanRevertPaymentReserveChanges: PermissionDefinition<{}>

  CanCreateProjects: PermissionDefinition<{}>
  CanViewProjects: PermissionDefinition<{}>
  CanEditProjects: PermissionDefinition<{}>
  CanDeleteProjects: PermissionDefinition<{}>

  CanCreateProjectCommissions: PermissionDefinition<{}>
  CanViewProjectCommissions: PermissionDefinition<{}>
  CanEditProjectCommissions: PermissionDefinition<{}>
  CanDeleteProjectCommissions: PermissionDefinition<{}>

  CanCreateProspects: PermissionDefinition<{}>
  CanViewProspects: PermissionDefinition<{}>
  CanEditProspects: PermissionDefinition<{}>
  CanViewUnqualifiedProspects: PermissionDefinition<{}>
  CanConvertProspects: PermissionDefinition<{}>
  CanManageProspectActivities: PermissionDefinition<{}>

  CanCreateQuotations: PermissionDefinition<{}>
  CanViewQuotations: PermissionDefinition<{}>
  CanEditQuotations: PermissionDefinition<{}>
  CanCancelQuotations: PermissionDefinition<{}>
  CanRequestQuotationCancellations: PermissionDefinition<{}>
  CanReviewQuotationCancellations: PermissionDefinition<{}>
  CanRemoveQuotationProducts: PermissionDefinition<{}>
  CanApproveDiscountQuatations: PermissionDefinition<{}>

  CanCreateReasonsForRequest: PermissionDefinition<{}>
  CanViewReasonsForRequest: PermissionDefinition<{}>
  CanEditReasonsForRequest: PermissionDefinition<{}>
  CanDeleteReasonsForRequest: PermissionDefinition<{}>

  CanCreateRoles: PermissionDefinition<{}>
  CanViewRoles: PermissionDefinition<{}>
  CanEditRoles: PermissionDefinition<{}>
  CanDeleteRoles: PermissionDefinition<{}>

  CanCreateStatuses: PermissionDefinition<{}>
  CanViewStatuses: PermissionDefinition<{}>
  CanEditStatuses: PermissionDefinition<{}>
  CanDeleteStatuses: PermissionDefinition<{}>

  CanCreateSubcategories: PermissionDefinition<{}>
  CanViewSubcategories: PermissionDefinition<{}>
  CanEditSubcategories: PermissionDefinition<{}>
  CanDeleteSubcategories: PermissionDefinition<{}>

  CanCreateTypeActivities: PermissionDefinition<{}>
  CanViewTypeActivities: PermissionDefinition<{}>
  CanEditTypeActivities: PermissionDefinition<{}>
  CanDeleteTypeActivities: PermissionDefinition<{}>



  CanCreateEvaluations: PermissionDefinition<{}>
  CanViewEvaluations: PermissionDefinition<{}>
  CanEditEvaluations: PermissionDefinition<{}>
  CanCloseEvaluations: PermissionDefinition<{}>
  CanApproveEscalatedEvaluations: PermissionDefinition<{}>

  CanCreateEvaluationReasons: PermissionDefinition<{}>
  CanViewEvaluationReasons: PermissionDefinition<{}>
  CanEditEvaluationReasons: PermissionDefinition<{}>
  CanDeleteEvaluationReasons: PermissionDefinition<{}>

  CanCreatePepTypes: PermissionDefinition<{}>
  CanViewPepTypes: PermissionDefinition<{}>
  CanEditPepTypes: PermissionDefinition<{}>
  CanDeletePepTypes: PermissionDefinition<{}>

  CanCreateTypeOrigins: PermissionDefinition<{}>
  CanViewTypeOrigins: PermissionDefinition<{}>
  CanEditTypeOrigins: PermissionDefinition<{}>
  CanDeleteTypeOrigins: PermissionDefinition<{}>

  CanCreateTypeStatuses: PermissionDefinition<{}>
  CanViewTypeStatuses: PermissionDefinition<{}>
  CanEditTypeStatuses: PermissionDefinition<{}>
  CanDeleteTypeStatuses: PermissionDefinition<{}>

  CanCreateUnitOfMeasurements: PermissionDefinition<{}>
  CanViewUnitOfMeasurements: PermissionDefinition<{}>
  CanEditUnitOfMeasurements: PermissionDefinition<{}>
  CanDeleteUnitOfMeasurements: PermissionDefinition<{}>

  CanCreateUsers: PermissionDefinition<{}>
  CanViewUsers: PermissionDefinition<{}>
  CanEditUsers: PermissionDefinition<{}>
  CanDeleteUsers: PermissionDefinition<{}>
  CanCreateUserBrokers: PermissionDefinition<{}>

  CanCreateUserCommissions: PermissionDefinition<{}>
  CanRemoveUserCommissions: PermissionDefinition<{}>
  CanCancelProductCommissions: PermissionDefinition<{}>
  CanEditUserCommissions: PermissionDefinition<{}>
  CanViewUserCommissions: PermissionDefinition<{}>

  CanCreateWinReasons: PermissionDefinition<{}>
  CanViewWinReasons: PermissionDefinition<{}>
  CanEditWinReasons: PermissionDefinition<{}>
  CanDeleteWinReasons: PermissionDefinition<{}>

  CanCreateLossReasons: PermissionDefinition<{}>
  CanViewLossReasons: PermissionDefinition<{}>
  CanEditLossReasons: PermissionDefinition<{}>
  CanDeleteLossReasons: PermissionDefinition<{}>

  CanViewBreakEvenPointKpi: PermissionDefinition<{}>
  CanViewPendingPremiumAmountReceivableSummaryKpi: PermissionDefinition<{}>
  CanViewProjectAreaSummaryKpi: PermissionDefinition<{}>
  CanViewProjectAreaSalePriceSummaryKpi: PermissionDefinition<{}>
  CanViewProjectIncomeSummaryKpi: PermissionDefinition<{}>
  CanViewProjectReservedIncomeSummaryKpi: PermissionDefinition<{}>
  CanViewProjectSubcategoriesSummaryKpi: PermissionDefinition<{}>
  CanViewTotalCommissionKpis: PermissionDefinition<{}>
  CanViewAdvisorKpis: PermissionDefinition<{}>
  CanViewOpportunitiesKpis: PermissionDefinition<{}>
  CanViewSalesPerMonthKpi: PermissionDefinition<{}>
  CanViewLeadsKpis: PermissionDefinition<{}>
  CanViewMarketingDashboard: PermissionDefinition<{}>
  CanViewGeneralLeadsReport: PermissionDefinition<{}>
  CanViewProductStatusKpis: PermissionDefinition<{}>
  CanViewTotalComparativeKpis: PermissionDefinition<{}>
  CanViewPaymentRequestKpi: PermissionDefinition<{}>
  CanViewClientsPerProjectKpi: PermissionDefinition<{}>
  CanViewAdvisorGoalKpi: PermissionDefinition<{}>
  CanViewAllKpis: PermissionDefinition<{}>

  CanViewTopQuoteProductReport: PermissionDefinition<{}>
  CanViewProductsByProjectReport: PermissionDefinition<{}>
  CanViewAvailableProductsReport: PermissionDefinition<{}>
  CanViewTopSoldProductReport: PermissionDefinition<{}>
  CanViewAdvisorActivitiesReport: PermissionDefinition<{}>
  CanViewOpportunityOriginsReport: PermissionDefinition<{}>
  CanViewPaymentHistoryReport: PermissionDefinition<{}>
  CanViewPaymentReservesHistoryReport: PermissionDefinition<{}>
  CanViewMasterOpportunityReport: PermissionDefinition<{}>
  CanViewMasterProspectReport: PermissionDefinition<{}>
  CanViewAdvisorGoalReport: PermissionDefinition<{}>
  CanViewClientQuoteReport: PermissionDefinition<{}>
  CanViewClientByProductReport: PermissionDefinition<{}>
  CanViewUnificatePaymentOrderReport: PermissionDefinition<{}>
  CanViewCustomerWalletReport: PermissionDefinition<{}>
  CanViewAdvisorPaymentStatusReport: PermissionDefinition<{}>
  CanViewCustomerPaymentStatusReport: PermissionDefinition<{}>
  CanViewOldBalancesReport: PermissionDefinition<{}>
  CanViewPendingWithdrawalReport: PermissionDefinition<{}>
  CanViewWithdrawalRequestsApprovedReport: PermissionDefinition<{}>
  CanViewPaidCommissionPerMonthReport: PermissionDefinition<{}>
  CanViewPendingPaymentCommissionReport: PermissionDefinition<{}>
  CanViewCommissionsPerProjectReport: PermissionDefinition<{}>
  CanViewCustomerInfoReport: PermissionDefinition<{}>
  CanViewCustomersHistoryReport: PermissionDefinition<{}>
  CanViewDocumentationComplianceReport: PermissionDefinition<{}>
  CanViewAccountsReceivableReport: PermissionDefinition<{}>
  CanViewCommissionsAvailableForPaymentReport: PermissionDefinition<{}>
  CanViewPendingPremiumAmountReceivableReport: PermissionDefinition<{}>
  CanViewProjectTotalReservedIncomeDetailReport: PermissionDefinition<{}>
  CanViewProjectTotalReservedIncomePaymentDetailReport: PermissionDefinition<{}>
  CanViewProductReservesDetailReport: PermissionDefinition<{}>
  CanViewPaymentOrdersFeesDetailReport: PermissionDefinition<{}>
  CanViewProductDatasheetReport: PermissionDefinition<{}>
  CanViewAllReports: PermissionDefinition<{}>

  CanExecuteJobs: PermissionDefinition<{}>

  CanCreateDiscardReasons: PermissionDefinition<{}>
  CanViewDiscardReasons: PermissionDefinition<{}>
  CanEditDiscardReasons: PermissionDefinition<{}>
  CanDeleteDiscardReasons: PermissionDefinition<{}>

  CanCreateProspectActivity: PermissionDefinition<{}>
  CanViewProspectActivity: PermissionDefinition<{}>
  CanEditProspectActivity: PermissionDefinition<{}>
  CanDeleteProspectActivity: PermissionDefinition<{}>

  CanCreatePaymentOrderActivity: PermissionDefinition<{}>
  CanViewPaymentOrderActivity: PermissionDefinition<{}>
  CanEditPaymentOrderActivity: PermissionDefinition<{}>
  CanDeletePaymentOrderActivity: PermissionDefinition<{}>

  CanCreateTypeActivityModule: PermissionDefinition<{}>
  CanViewTypeActivityModule: PermissionDefinition<{}>
  CanEditTypeActivityModule: PermissionDefinition<{}>
  CanDeleteTypeActivityModule: PermissionDefinition<{}>

  CanCreateTypeDocumentModule: PermissionDefinition<{}>
  CanViewTypeDocumentModule: PermissionDefinition<{}>
  CanEditTypeDocumentModule: PermissionDefinition<{}>
  CanDeleteTypeDocumentModule: PermissionDefinition<{}>

  CanChangeApplyProductCommission: PermissionDefinition<{}>
  CanReciveEmailCreateCommission: PermissionDefinition<{}>
  CanReciveEmailPendingReviewCommission: PermissionDefinition<{}>
  CanReciveEmailPendingReviewAccountingCommission: PermissionDefinition<{}>
  CanReciveEmailSignatureSaleAdvisorCommission: PermissionDefinition<{}>
  CanReciveEmailSignatureSaleAdvisorApproveCommission: PermissionDefinition<{}>
  CanReciveEmailCheckAccountingCommission: PermissionDefinition<{}>
  CanReciveEmailApplyPaymentAccountingCommission: PermissionDefinition<{}>

  CanRequestPenaltyPaymentCommissions: PermissionDefinition<{}>
  CanReceiveEmailPenaltyCommission: PermissionDefinition<{}>
  CanViewRequestPenaltyPaymentCommissions: PermissionDefinition<{}>
  CanCancelRequestPenaltyPaymentCommissions: PermissionDefinition<{}>
  CanApproveRequestPenaltyPaymentCommissions: PermissionDefinition<{}>

  CanCreateAdvisorGroup: PermissionDefinition<{}>
  CanViewAdvisorGroup: PermissionDefinition<{}>
  CanEditAdvisorGroup: PermissionDefinition<{}>
  CanDeleteAdvisorGroup: PermissionDefinition<{}>

  CanViewGoalKpi: PermissionDefinition<{}>
  CanCreateGoal: PermissionDefinition<{}>
  CanViewGoal: PermissionDefinition<{}>
  CanEditGoal: PermissionDefinition<{}>
  CanDeleteGoal: PermissionDefinition<{}>
  CanCreateGoalMetric: PermissionDefinition<{}>
  CanViewGoalMetric: PermissionDefinition<{}>
  CanEditGoalMetric: PermissionDefinition<{}>
  CanDeleteGoalMetric: PermissionDefinition<{}>

  CanCreateNotifications: PermissionDefinition<{}>
  CanViewNotifications: PermissionDefinition<{}>
  CanEditNotifications: PermissionDefinition<{}>
  CanDeleteNotifications: PermissionDefinition<{}>

  CanCreateProductDeliveries: PermissionDefinition<{}>
  CanViewProductDeliveries: PermissionDefinition<{}>
  CanReviewProductDeliveryFinancingProcesses: PermissionDefinition<{}>
  CanReviewProductDeliveryLegalProcess: PermissionDefinition<{}>
  CanManageProductDeliveryProtocolSign: PermissionDefinition<{}>
  CanManageProductDeliveryDisbursements: PermissionDefinition<{}>
  CanCancelProductDeliveries: PermissionDefinition<{}>
  CanManageProductDeliveryDocuments: PermissionDefinition<{}>
  CanMoveProductDeliveriesThroughTransitionalSteps: PermissionDefinition<{}>

  CanCreateProspectStatus: PermissionDefinition<{}>
  CanViewProspectStatus: PermissionDefinition<{}>
  CanEditProspectStatus: PermissionDefinition<{}>
  CanDeleteProspectStatus: PermissionDefinition<{}>
  CanCreateProspectStepStatus: PermissionDefinition<{}>
  CanViewProspectStepStatus: PermissionDefinition<{}>
  CanUpdateProspectStepStatus: PermissionDefinition<{}>
  CanModifyFinalizedProductDeliveries: PermissionDefinition<{}>
  CanEditProductInspection: PermissionDefinition<{}>

  CanRequestOverdueCondone: PermissionDefinition<{}>
  CanApproveOverdueCondone: PermissionDefinition<{}>
  CanApplyPaymentOrderDiscount: PermissionDefinition<{}>
  CanApprovePaymentOrderDiscount: PermissionDefinition<{}>
  CanAdditionalPaymentOrderFee: PermissionDefinition<{}>
  CanSyncPaymentOrderInvoice: PermissionDefinition<{}>

  CanCreateDiscountTypes: PermissionDefinition<{}>
  CanEditDiscountTypes: PermissionDefinition<{}>
  CanViewDiscountTypes: PermissionDefinition<{}>
  CanDeleteDiscountTypes: PermissionDefinition<{}>
  
  CanViewExchangeRates: PermissionDefinition<{}>
  CanCreateExchangeRates: PermissionDefinition<{}>
  CanEditExchangeRates: PermissionDefinition<{}>
  CanRunExchangeRateSync: PermissionDefinition<{}>

  CanViewOpportunityStepTransitionTimeReport: PermissionDefinition<{}>

  CanConfigureOpportunityStageGoals: PermissionDefinition<{}>

  CanEditOpportunityStageGoalTargets: PermissionDefinition<{}>

  CanViewOwnGoalCommissions: PermissionDefinition<{}>
  CanViewGoalCommissions: PermissionDefinition<{}>
  CanReviewGoalCommissionItems: PermissionDefinition<{}>
  CanProposeGoalCommissionPayments: PermissionDefinition<{}>
  CanApproveGoalCommissionRequests: PermissionDefinition<{}>
  CanResolveGoalCommissionIncidents: PermissionDefinition<{}>
  CanManageGoalCommissionSettings: PermissionDefinition<{}>
}

function createPermission<T = {}>(params: {
  permissionId: number
  permissions: Permissions[]
  permissionSelector: string
  permissionFunction?: (params: HasPermissionParams & T) => boolean
}): PermissionDefinition<T> {
  const { permissionId, permissions, permissionSelector, permissionFunction } =
    params

  return {
    permissionId,
    permissionSelector,
    permissions,
    hasPermission: permissionFunction
      ? (params) => permissionFunction(params)
      : (params) =>
          permissions.every((permission) =>
            params.user.permissions.includes(permission)
          )
  }
}

export const PERMISSIONS: PermissionMap = {
  CanCreateAccountSettlements: createPermission({
    permissionId: 1,
    permissionSelector: Permissions.CanCreateAccountSettlements,
    permissions: [Permissions.CanCreateAccountSettlements]
  }),
  CanReviewAccountSettlements: createPermission({
    permissionId: 2,
    permissionSelector: Permissions.CanReviewAccountSettlements,
    permissions: [Permissions.CanReviewAccountSettlements]
  }),
  CanRequestAccountSettlementCancellation: createPermission({
    permissionId: 3,
    permissionSelector: Permissions.CanRequestAccountSettlementCancellation,
    permissions: [Permissions.CanRequestAccountSettlementCancellation]
  }),
  CanReviewAccountSettlementCancellation: createPermission({
    permissionId: 4,
    permissionSelector: Permissions.CanReviewAccountSettlementCancellation,
    permissions: [Permissions.CanReviewAccountSettlementCancellation]
  }),
  CanViewAccountSettlements: createPermission({
    permissionId: 5,
    permissionSelector: Permissions.CanViewAccountSettlements,
    permissions: [Permissions.CanViewAccountSettlements]
  }),

  CanSendAdCampaigns: createPermission({
    permissionId: 9,
    permissionSelector: Permissions.CanSendAdCampaigns,
    permissions: [Permissions.CanSendAdCampaigns]
  }),

  CanAssignAdvisorDepartments: createPermission({
    permissionId: 10,
    permissionSelector: Permissions.CanAssignAdvisorDepartments,
    permissions: [Permissions.CanAssignAdvisorDepartments]
  }),

  CanAssignAdvisorProjects: createPermission({
    permissionId: 20,
    permissionSelector: Permissions.CanAssignAdvisorProjects,
    permissions: [Permissions.CanAssignAdvisorProjects]
  }),

  CanCreateBanks: createPermission({
    permissionId: 25,
    permissionSelector: Permissions.CanCreateBanks,
    permissions: [Permissions.CanCreateBanks]
  }),
  CanEditBanks: createPermission({
    permissionId: 26,
    permissionSelector: Permissions.CanEditBanks,
    permissions: [Permissions.CanEditBanks]
  }),
  CanViewBanks: createPermission({
    permissionId: 27,
    permissionSelector: Permissions.CanViewBanks,
    permissions: [Permissions.CanViewBanks]
  }),

  CanCreateBanners: createPermission({
    permissionId: 30,
    permissionSelector: Permissions.CanCreateBanners,
    permissions: [Permissions.CanCreateBanners]
  }),
  CanDeleteBanners: createPermission({
    permissionId: 31,
    permissionSelector: Permissions.CanDeleteBanners,
    permissions: [Permissions.CanDeleteBanners]
  }),
  CanViewBanners: createPermission({
    permissionId: 32,
    permissionSelector: Permissions.CanViewBanners,
    permissions: [Permissions.CanViewBanners]
  }),

  CanCreateCategories: createPermission({
    permissionId: 35,
    permissionSelector: Permissions.CanCreateCategories,
    permissions: [Permissions.CanCreateCategories]
  }),
  CanEditCategories: createPermission({
    permissionId: 36,
    permissionSelector: Permissions.CanEditCategories,
    permissions: [Permissions.CanEditCategories]
  }),
  CanDeleteCategories: createPermission({
    permissionId: 37,
    permissionSelector: Permissions.CanDeleteCategories,
    permissions: [Permissions.CanDeleteCategories]
  }),
  CanViewCategories: createPermission({
    permissionId: 38,
    permissionSelector: Permissions.CanViewCategories,
    permissions: [Permissions.CanViewCategories]
  }),

  CanCreateCessionOfRights: createPermission({
    permissionId: 40,
    permissionSelector: Permissions.CanCreateCessionOfRights,
    permissions: [Permissions.CanCreateCessionOfRights]
  }),
  CanReviewCessionOfRights: createPermission({
    permissionId: 41,
    permissionSelector: Permissions.CanReviewCessionOfRights,
    permissions: [Permissions.CanReviewCessionOfRights]
  }),
  CanReviewCessionOfRightPayments: createPermission({
    permissionId: 42,
    permissionSelector: Permissions.CanReviewCessionOfRightPayments,
    permissions: [Permissions.CanReviewCessionOfRightPayments]
  }),
  CanViewCessionOfRights: createPermission({
    permissionId: 43,
    permissionSelector: Permissions.CanViewCessionOfRights,
    permissions: [Permissions.CanViewCessionOfRights]
  }),
  CanCreateCessionOfRightContractElaboration: createPermission({
    permissionId: 44,
    permissionSelector: Permissions.CanCreateCessionOfRightContractElaboration,
    permissions: [Permissions.CanCreateCessionOfRightContractElaboration]
  }),

  CanReviewChangeOfProducts: createPermission({
    permissionId: 45,
    permissionSelector: Permissions.CanReviewChangeOfProducts,
    permissions: [Permissions.CanReviewChangeOfProducts]
  }),
  CanRequestChangeOfProducts: createPermission({
    permissionId: 46,
    permissionSelector: Permissions.CanRequestChangeOfProducts,
    permissions: [Permissions.CanRequestChangeOfProducts]
  }),
  CanViewChangeOfProducts: createPermission({
    permissionId: 47,
    permissionSelector: Permissions.CanViewChangeOfProducts,
    permissions: [Permissions.CanViewChangeOfProducts]
  }),
  CanExecuteChangeOfProducts: createPermission({
    permissionId: 48,
    permissionSelector: Permissions.CanExecuteChangeOfProducts,
    permissions: [Permissions.CanExecuteChangeOfProducts]
  }),

  CanRequestChangeTotalToPaid: createPermission({
    permissionId: 50,
    permissionSelector: Permissions.CanRequestChangeTotalToPaid,
    permissions: [Permissions.CanRequestChangeTotalToPaid]
  }),
  CanReviewChangeTotalToPaid: createPermission({
    permissionId: 51,
    permissionSelector: Permissions.CanReviewChangeTotalToPaid,
    permissions: [Permissions.CanReviewChangeTotalToPaid]
  }),
  CanExecuteChangeTotalToPaid: createPermission({
    permissionId: 52,
    permissionSelector: Permissions.CanExecuteChangeTotalToPaid,
    permissions: [Permissions.CanExecuteChangeTotalToPaid]
  }),

  CanCreateCities: createPermission({
    permissionId: 55,
    permissionSelector: Permissions.CanCreateCities,
    permissions: [Permissions.CanCreateCities]
  }),
  CanViewCities: createPermission({
    permissionId: 56,
    permissionSelector: Permissions.CanViewCities,
    permissions: [Permissions.CanViewCities]
  }),
  CanEditCities: createPermission({
    permissionId: 57,
    permissionSelector: Permissions.CanEditCities,
    permissions: [Permissions.CanEditCities]
  }),
  CanDeleteCities: createPermission({
    permissionId: 58,
    permissionSelector: Permissions.CanDeleteCities,
    permissions: [Permissions.CanDeleteCities]
  }),

  CanCreateCommissionTypes: createPermission({
    permissionId: 60,
    permissionSelector: Permissions.CanCreateCommissionTypes,
    permissions: [Permissions.CanCreateCommissionTypes]
  }),
  CanViewCommissionTypes: createPermission({
    permissionId: 61,
    permissionSelector: Permissions.CanViewCommissionTypes,
    permissions: [Permissions.CanViewCommissionTypes]
  }),
  CanEditCommissionTypes: createPermission({
    permissionId: 62,
    permissionSelector: Permissions.CanEditCommissionTypes,
    permissions: [Permissions.CanEditCommissionTypes]
  }),
  CanDeleteCommissionTypes: createPermission({
    permissionId: 63,
    permissionSelector: Permissions.CanDeleteCommissionTypes,
    permissions: [Permissions.CanDeleteCommissionTypes]
  }),

  CanCreateCompanies: createPermission({
    permissionId: 65,
    permissionSelector: Permissions.CanCreateCompanies,
    permissions: [Permissions.CanCreateCompanies]
  }),
  CanViewCompanies: createPermission({
    permissionId: 66,
    permissionSelector: Permissions.CanViewCompanies,
    permissions: [Permissions.CanViewCompanies]
  }),
  CanEditCompanies: createPermission({
    permissionId: 67,
    permissionSelector: Permissions.CanEditCompanies,
    permissions: [Permissions.CanEditCompanies]
  }),
  CanDeleteCompanies: createPermission({
    permissionId: 68,
    permissionSelector: Permissions.CanDeleteCompanies,
    permissions: [Permissions.CanDeleteCompanies]
  }),

  CanCreateCountries: createPermission({
    permissionId: 70,
    permissionSelector: Permissions.CanCreateCountries,
    permissions: [Permissions.CanCreateCountries]
  }),
  CanViewCountries: createPermission({
    permissionId: 71,
    permissionSelector: Permissions.CanViewCountries,
    permissions: [Permissions.CanViewCountries]
  }),
  CanEditCountries: createPermission({
    permissionId: 72,
    permissionSelector: Permissions.CanEditCountries,
    permissions: [Permissions.CanEditCountries]
  }),
  CanDeleteCountries: createPermission({
    permissionId: 73,
    permissionSelector: Permissions.CanDeleteCountries,
    permissions: [Permissions.CanDeleteCountries]
  }),

  CanCreateCustomers: createPermission({
    permissionId: 75,
    permissionSelector: Permissions.CanCreateCustomers,
    permissions: [Permissions.CanCreateCustomers]
  }),
  CanViewCustomers: createPermission({
    permissionId: 76,
    permissionSelector: Permissions.CanViewCustomers,
    permissions: [Permissions.CanViewCustomers]
  }),
  CanEditCustomers: createPermission({
    permissionId: 77,
    permissionSelector: Permissions.CanEditCustomers,
    permissions: [Permissions.CanEditCustomers]
  }),
  CanEditCustomersByExcel: createPermission({
    permissionId: 78,
    permissionSelector: Permissions.CanEditCustomersByExcel,
    permissions: [Permissions.CanEditCustomersByExcel]
  }),
  CanDeleteCustomers: createPermission({
    permissionId: 79,
    permissionSelector: Permissions.CanDeleteCustomers,
    permissions: [Permissions.CanDeleteCustomers]
  }),

  CanCreateDataSheets: createPermission({
    permissionId: 85,
    permissionSelector: Permissions.CanCreateDataSheets,
    permissions: [Permissions.CanCreateDataSheets]
  }),
  CanViewDataSheets: createPermission({
    permissionId: 86,
    permissionSelector: Permissions.CanViewDataSheets,
    permissions: [Permissions.CanViewDataSheets]
  }),
  CanEditDataSheets: createPermission({
    permissionId: 87,
    permissionSelector: Permissions.CanEditDataSheets,
    permissions: [Permissions.CanEditDataSheets]
  }),
  CanDeleteDataSheets: createPermission({
    permissionId: 88,
    permissionSelector: Permissions.CanDeleteDataSheets,
    permissions: [Permissions.CanDeleteDataSheets]
  }),

  CanCreateDepartments: createPermission({
    permissionId: 90,
    permissionSelector: Permissions.CanCreateDepartments,
    permissions: [Permissions.CanCreateDepartments]
  }),
  CanViewDepartments: createPermission({
    permissionId: 91,
    permissionSelector: Permissions.CanViewDepartments,
    permissions: [Permissions.CanViewDepartments]
  }),
  CanEditDepartments: createPermission({
    permissionId: 92,
    permissionSelector: Permissions.CanEditDepartments,
    permissions: [Permissions.CanEditDepartments]
  }),
  CanDeleteDepartments: createPermission({
    permissionId: 93,
    permissionSelector: Permissions.CanDeleteDepartments,
    permissions: [Permissions.CanDeleteDepartments]
  }),

  CanCreateDocumentTypes: createPermission({
    permissionId: 95,
    permissionSelector: Permissions.CanCreateDocumentTypes,
    permissions: [Permissions.CanCreateDocumentTypes]
  }),
  CanViewDocumentTypes: createPermission({
    permissionId: 96,
    permissionSelector: Permissions.CanViewDocumentTypes,
    permissions: [Permissions.CanViewDocumentTypes]
  }),
  CanEditDocumentTypes: createPermission({
    permissionId: 97,
    permissionSelector: Permissions.CanEditDocumentTypes,
    permissions: [Permissions.CanEditDocumentTypes]
  }),
  CanDeleteDocumentTypes: createPermission({
    permissionId: 98,
    permissionSelector: Permissions.CanDeleteDocumentTypes,
    permissions: [Permissions.CanDeleteDocumentTypes]
  }),

  CanCreateHeroSliders: createPermission({
    permissionId: 100,
    permissionSelector: Permissions.CanCreateHeroSliders,
    permissions: [Permissions.CanCreateHeroSliders]
  }),
  CanViewHeroSliders: createPermission({
    permissionId: 101,
    permissionSelector: Permissions.CanViewHeroSliders,
    permissions: [Permissions.CanViewHeroSliders]
  }),
  CanEditHeroSliders: createPermission({
    permissionId: 102,
    permissionSelector: Permissions.CanEditHeroSliders,
    permissions: [Permissions.CanEditHeroSliders]
  }),
  CanDeleteHeroSliders: createPermission({
    permissionId: 103,
    permissionSelector: Permissions.CanDeleteHeroSliders,
    permissions: [Permissions.CanDeleteHeroSliders]
  }),

  CanCreateInterestLevels: createPermission({
    permissionId: 105,
    permissionSelector: Permissions.CanCreateInterestLevels,
    permissions: [Permissions.CanCreateInterestLevels]
  }),
  CanViewInterestLevels: createPermission({
    permissionId: 106,
    permissionSelector: Permissions.CanViewInterestLevels,
    permissions: [Permissions.CanViewInterestLevels]
  }),
  CanEditInterestLevels: createPermission({
    permissionId: 107,
    permissionSelector: Permissions.CanEditInterestLevels,
    permissions: [Permissions.CanEditInterestLevels]
  }),
  CanDeleteInterestLevels: createPermission({
    permissionId: 108,
    permissionSelector: Permissions.CanDeleteInterestLevels,
    permissions: [Permissions.CanDeleteInterestLevels]
  }),

  CanCreateMessages: createPermission({
    permissionId: 110,
    permissionSelector: Permissions.CanCreateMessages,
    permissions: [Permissions.CanCreateMessages]
  }),
  CanViewMessages: createPermission({
    permissionId: 111,
    permissionSelector: Permissions.CanViewMessages,
    permissions: [Permissions.CanViewMessages]
  }),

  CanCreateOpportunities: createPermission({
    permissionId: 115,
    permissionSelector: Permissions.CanCreateOpportunities,
    permissions: [Permissions.CanCreateOpportunities]
  }),
  CanViewOpportunities: createPermission({
    permissionId: 116,
    permissionSelector: Permissions.CanViewOpportunities,
    permissions: [Permissions.CanViewOpportunities]
  }),
  CanEditOpportunities: createPermission({
    permissionId: 117,
    permissionSelector: Permissions.CanEditOpportunities,
    permissions: [Permissions.CanEditOpportunities]
  }),
  CanDeleteOpportunities: createPermission({
    permissionId: 118,
    permissionSelector: Permissions.CanDeleteOpportunities,
    permissions: [Permissions.CanDeleteOpportunities]
  }),
  CanManageOpportunityActivities: createPermission({
    permissionId: 119,
    permissionSelector: Permissions.CanManageOpportunityActivities,
    permissions: [Permissions.CanManageOpportunityActivities]
  }),
  CanCommentOpportunities: createPermission({
    permissionId: 120,
    permissionSelector: Permissions.CanCommentOpportunities,
    permissions: [Permissions.CanCommentOpportunities]
  }),
  CanDeleteOpportunityComments: createPermission({
    permissionId: 121,
    permissionSelector: Permissions.CanDeleteOpportunityComments,
    permissions: [Permissions.CanDeleteOpportunityComments]
  }),
  CanManageOpportunityDocuments: createPermission({
    permissionId: 122,
    permissionSelector: Permissions.CanManageOpportunityDocuments,
    permissions: [Permissions.CanManageOpportunityDocuments]
  }),
  CanChangeOpportunitySaleAdvisors: createPermission({
    permissionId: 123,
    permissionSelector: Permissions.CanChangeOpportunitySaleAdvisors,
    permissions: [Permissions.CanChangeOpportunitySaleAdvisors]
  }),

  CanCreateOpportunitySteps: createPermission({
    permissionId: 125,
    permissionSelector: Permissions.CanCreateOpportunitySteps,
    permissions: [Permissions.CanCreateOpportunitySteps]
  }),
  CanViewOpportunitySteps: createPermission({
    permissionId: 126,
    permissionSelector: Permissions.CanViewOpportunitySteps,
    permissions: [Permissions.CanViewOpportunitySteps]
  }),
  CanEditOpportunitySteps: createPermission({
    permissionId: 127,
    permissionSelector: Permissions.CanEditOpportunitySteps,
    permissions: [Permissions.CanEditOpportunitySteps]
  }),
  CanDeleteOpportunitySteps: createPermission({
    permissionId: 128,
    permissionSelector: Permissions.CanDeleteOpportunitySteps,
    permissions: [Permissions.CanDeleteOpportunitySteps]
  }),

  CanCreatePaymentAccounts: createPermission({
    permissionId: 130,
    permissionSelector: Permissions.CanCreatePaymentAccounts,
    permissions: [Permissions.CanCreatePaymentAccounts]
  }),
  CanViewPaymentAccounts: createPermission({
    permissionId: 131,
    permissionSelector: Permissions.CanViewPaymentAccounts,
    permissions: [Permissions.CanViewPaymentAccounts]
  }),
  CanEditPaymentAccounts: createPermission({
    permissionId: 132,
    permissionSelector: Permissions.CanEditPaymentAccounts,
    permissions: [Permissions.CanEditPaymentAccounts]
  }),
  CanDeletePaymentAccounts: createPermission({
    permissionId: 133,
    permissionSelector: Permissions.CanDeletePaymentAccounts,
    permissions: [Permissions.CanDeletePaymentAccounts]
  }),

  CanRequestPaymentCommissions: createPermission({
    permissionId: 135,
    permissionSelector: Permissions.CanRequestPaymentCommissions,
    permissions: [Permissions.CanRequestPaymentCommissions]
  }),
  CanReviewPaymentCommissions: createPermission({
    permissionId: 136,
    permissionSelector: Permissions.CanReviewPaymentCommissions,
    permissions: [Permissions.CanReviewPaymentCommissions]
  }),
  CanApplyPaymentCommissions: createPermission({
    permissionId: 137,
    permissionSelector: Permissions.CanApplyPaymentCommissions,
    permissions: [Permissions.CanApplyPaymentCommissions]
  }),
  CanViewPaymentCommissions: createPermission({
    permissionId: 138,
    permissionSelector: Permissions.CanViewPaymentCommissions,
    permissions: [Permissions.CanViewPaymentCommissions]
  }),
  CanImportPaymentCommissions: createPermission({
    permissionId: 139,
    permissionSelector: Permissions.CanImportPaymentCommissions,
    permissions: [Permissions.CanImportPaymentCommissions]
  }),

  CanCreatePaymentOrders: createPermission({
    permissionId: 140,
    permissionSelector: Permissions.CanCreatePaymentOrders,
    permissions: [Permissions.CanCreatePaymentOrders]
  }),
  CanChangePaymentOrderPeriod: createPermission({
    permissionId: 141,
    permissionSelector: Permissions.CanChangePaymentOrderPeriod,
    permissions: [Permissions.CanChangePaymentOrderPeriod]
  }),
  CanViewPaymentOrders: createPermission({
    permissionId: 142,
    permissionSelector: Permissions.CanViewPaymentOrders,
    permissions: [Permissions.CanViewPaymentOrders]
  }),
  CanAdjustPaymentOrderPaymentDates: createPermission({
    permissionId: 143,
    permissionSelector: Permissions.CanAdjustPaymentOrderPaymentDates,
    permissions: [Permissions.CanAdjustPaymentOrderPaymentDates]
  }),
  CanRequestPaymentOrderPenalties: createPermission({
    permissionId: 144,
    permissionSelector: Permissions.CanRequestPaymentOrderPenalties,
    permissions: [Permissions.CanRequestPaymentOrderPenalties]
  }),
  CanReviewPaymentOrderPenalties: createPermission({
    permissionId: 145,
    permissionSelector: Permissions.CanReviewPaymentOrderPenalties,
    permissions: [Permissions.CanReviewPaymentOrderPenalties]
  }),
  CanRequestPaymentOrderWithdrawals: createPermission({
    permissionId: 146,
    permissionSelector: Permissions.CanRequestPaymentOrderWithdrawals,
    permissions: [Permissions.CanRequestPaymentOrderWithdrawals]
  }),
  CanReviewPaymentOrderWithdrawals: createPermission({
    permissionId: 147,
    permissionSelector: Permissions.CanReviewPaymentOrderWithdrawals,
    permissions: [Permissions.CanReviewPaymentOrderWithdrawals]
  }),
  CanSendPaymentReceipts: createPermission({
    permissionId: 148,
    permissionSelector: Permissions.CanSendPaymentReceipts,
    permissions: [Permissions.CanSendPaymentReceipts]
  }),
  CanSendPaymentReminders: createPermission({
    permissionId: 149,
    permissionSelector: Permissions.CanSendPaymentReminders,
    permissions: [Permissions.CanSendPaymentReminders]
  }),
  CanSendAccountStatuses: createPermission({
    permissionId: 150,
    permissionSelector: Permissions.CanSendAccountStatuses,
    permissions: [Permissions.CanSendAccountStatuses]
  }),
  CanSetCustomFees: createPermission({
    permissionId: 151,
    permissionSelector: Permissions.CanSetCustomFees,
    permissions: [Permissions.CanSetCustomFees]
  }),
  CanSetTaxRateReserves: createPermission({
    permissionId: 152,
    permissionSelector: Permissions.CanSetTaxRateReserves,
    permissions: [Permissions.CanSetTaxRateReserves]
  }),
  CanRequestWithdrawalBankChecks: createPermission({
    permissionId: 153,
    permissionSelector: Permissions.CanRequestWithdrawalBankChecks,
    permissions: [Permissions.CanRequestWithdrawalBankChecks]
  }),
  CanAddWithdrawalChecks: createPermission({
    permissionId: 154,
    permissionSelector: Permissions.CanAddWithdrawalChecks,
    permissions: [Permissions.CanAddWithdrawalChecks]
  }),
  CanEditPaymentOrders: createPermission({
    permissionId: 155,
    permissionSelector: Permissions.CanEditPaymentOrders,
    permissions: [Permissions.CanEditPaymentOrders]
  }),
  CanEditPaymentOrderPremium: createPermission({
    permissionId: 1117,
    permissionSelector: Permissions.CanEditPaymentOrderPremium,
    permissions: [Permissions.CanEditPaymentOrderPremium]
  }),
  CanUpdatePaymentBalances: createPermission({
    permissionId: 156,
    permissionSelector: Permissions.CanUpdatePaymentBalances,
    permissions: [Permissions.CanUpdatePaymentBalances]
  }),

  CanReviewAccountingPaymentCommissions: createPermission({
    permissionId: 157,
    permissionSelector: Permissions.CanReviewAccountingPaymentCommissions,
    permissions: [Permissions.CanReviewAccountingPaymentCommissions],
  }),
  CanCancelRequestPaymentCommissions: createPermission({
    permissionId: 158,
    permissionSelector: Permissions.CanCancelRequestPaymentCommissions,
    permissions: [Permissions.CanCancelRequestPaymentCommissions],
  }),
  CanApprovePaymentOrder: createPermission({
    permissionId: 159,
    permissionSelector: Permissions.CanApprovePaymentOrder,
    permissions: [Permissions.CanApprovePaymentOrder],
  }),

  CanRequestPayments: createPermission({
    permissionId: 300,
    permissionSelector: Permissions.CanRequestPayments,
    permissions: [Permissions.CanRequestPayments]
  }),
  CanReviewPaymentRequests: createPermission({
    permissionId: 301,
    permissionSelector: Permissions.CanReviewPaymentRequests,
    permissions: [Permissions.CanReviewPaymentRequests]
  }),
  CanCreatePayments: createPermission({
    permissionId: 302,
    permissionSelector: Permissions.CanCreatePayments,
    permissions: [Permissions.CanCreatePayments]
  }),
  CanRequestPaymentModifications: createPermission({
    permissionId: 303,
    permissionSelector: Permissions.CanRequestPaymentModifications,
    permissions: [Permissions.CanRequestPaymentModifications]
  }),
  CanReviewPaymentModifications: createPermission({
    permissionId: 304,
    permissionSelector: Permissions.CanReviewPaymentModifications,
    permissions: [Permissions.CanReviewPaymentModifications]
  }),
  CanCreateExtraordinaryPayments: createPermission({
    permissionId: 305,
    permissionSelector: Permissions.CanCreateExtraordinaryPayments,
    permissions: [Permissions.CanCreateExtraordinaryPayments]
  }),
  CanRequestMovePayments: createPermission({
    permissionId: 306,
    permissionSelector: Permissions.CanRequestMovePayments,
    permissions: [Permissions.CanRequestMovePayments]
  }),
  CanReviewMovePayments: createPermission({
    permissionId: 307,
    permissionSelector: Permissions.CanReviewMovePayments,
    permissions: [Permissions.CanReviewMovePayments]
  }),
  CanEditPayments: createPermission({
    permissionId: 308,
    permissionSelector: Permissions.CanEditPayments,
    permissions: [Permissions.CanEditPayments]
  }),
  CanRequestPaymentCancellations: createPermission({
    permissionId: 309,
    permissionSelector: Permissions.CanRequestPaymentCancellations,
    permissions: [Permissions.CanRequestPaymentCancellations]
  }),
  CanReviewPaymentCancellations: createPermission({
    permissionId: 310,
    permissionSelector: Permissions.CanReviewPaymentCancellations,
    permissions: [Permissions.CanReviewPaymentCancellations]
  }),
  CanCancelPayments: createPermission({
    permissionId: 311,
    permissionSelector: Permissions.CanCancelPayments,
    permissions: [Permissions.CanCancelPayments]
  }),
  CanMovePaymentToReservation: createPermission({
    permissionId: 312,
    permissionSelector: Permissions.CanMovePaymentToReservation,
    permissions: [Permissions.CanMovePaymentToReservation]
  }),
  CanRevertPaymentChanges: createPermission({
    permissionId: 313,
    permissionSelector: Permissions.CanRevertPaymentChanges,
    permissions: [Permissions.CanRevertPaymentChanges]
  }),
  CanViewPaymentRequests: createPermission({
    permissionId: 314,
    permissionSelector: Permissions.CanViewPaymentRequests,
    permissions: [Permissions.CanViewPaymentRequests]
  }),
  CanReciveEmailPaymentRequest: createPermission({
    permissionId: 315,
    permissionSelector: Permissions.CanReciveEmailPaymentRequest,
    permissions: [Permissions.CanReciveEmailPaymentRequest],
  }),

  CanCreateProducts: createPermission({
    permissionId: 320,
    permissionSelector: Permissions.CanCreateProducts,
    permissions: [Permissions.CanCreateProducts]
  }),
  CanViewProducts: createPermission({
    permissionId: 321,
    permissionSelector: Permissions.CanViewProducts,
    permissions: [Permissions.CanViewProducts]
  }),
  CanEditProducts: createPermission({
    permissionId: 322,
    permissionSelector: Permissions.CanEditProducts,
    permissions: [Permissions.CanEditProducts]
  }),
  CanDeleteProducts: createPermission({
    permissionId: 323,
    permissionSelector: Permissions.CanDeleteProducts,
    permissions: [Permissions.CanDeleteProducts]
  }),
  CanChangeProductSalePrices: createPermission({
    permissionId: 324,
    permissionSelector: Permissions.CanChangeProductSalePrices,
    permissions: [Permissions.CanChangeProductSalePrices]
  }),
  CanEditProductDataSheets: createPermission({
    permissionId: 325,
    permissionSelector: Permissions.CanEditProductDataSheets,
    permissions: [Permissions.CanEditProductDataSheets]
  }),
  CanEditProductImages: createPermission({
    permissionId: 326,
    permissionSelector: Permissions.CanEditProductImages,
    permissions: [Permissions.CanEditProductImages]
  }),

  CanEditProductInspection: createPermission({
    permissionId: 327,
    permissionSelector: Permissions.CanEditProductInspection,
    permissions: [Permissions.CanEditProductInspection]
  }),

  CanCreateProductReserves: createPermission({
    permissionId: 160,
    permissionSelector: Permissions.CanCreateProductReserves,
    permissions: [Permissions.CanCreateProductReserves]
  }),
  CanRequestProductReserveChanges: createPermission({
    permissionId: 161,
    permissionSelector: Permissions.CanRequestProductReserveChanges,
    permissions: [Permissions.CanRequestProductReserveChanges]
  }),
  CanReviewProductReserveChanges: createPermission({
    permissionId: 162,
    permissionSelector: Permissions.CanReviewProductReserveChanges,
    permissions: [Permissions.CanReviewProductReserveChanges]
  }),
  CanChangeProductReserveTotals: createPermission({
    permissionId: 163,
    permissionSelector: Permissions.CanChangeProductReserveTotals,
    permissions: [Permissions.CanChangeProductReserveTotals]
  }),
  CanRevertProductReserveChanges: createPermission({
    permissionId: 164,
    permissionSelector: Permissions.CanRevertProductReserveChanges,
    permissions: [Permissions.CanRevertProductReserveChanges]
  }),

  CanCreatePaymentReserve: createPermission({
    permissionId: 170,
    permissionSelector: Permissions.CanCreatePaymentReserve,
    permissions: [Permissions.CanCreatePaymentReserve]
  }),
  CanEditPaymentReserve: createPermission({
    permissionId: 171,
    permissionSelector: Permissions.CanEditPaymentReserve,
    permissions: [Permissions.CanEditPaymentReserve]
  }),
  CanRequestPaymentReserveChanges: createPermission({
    permissionId: 172,
    permissionSelector: Permissions.CanRequestPaymentReserveChanges,
    permissions: [Permissions.CanRequestPaymentReserveChanges]
  }),
  CanReviewPaymentReserveChanges: createPermission({
    permissionId: 173,
    permissionSelector: Permissions.CanReviewPaymentReserveChanges,
    permissions: [Permissions.CanReviewPaymentReserveChanges]
  }),
  CanCancelPaymentReserve: createPermission({
    permissionId: 174,
    permissionSelector: Permissions.CanCancelPaymentReserve,
    permissions: [Permissions.CanCancelPaymentReserve]
  }),
  CanRequestPaymentReserveCancellations: createPermission({
    permissionId: 175,
    permissionSelector: Permissions.CanRequestPaymentReserveCancellations,
    permissions: [Permissions.CanRequestPaymentReserveCancellations]
  }),
  CanReviewPaymentReserveCancellations: createPermission({
    permissionId: 176,
    permissionSelector: Permissions.CanReviewPaymentReserveCancellations,
    permissions: [Permissions.CanReviewPaymentReserveCancellations]
  }),
  CanRevertPaymentReserveChanges: createPermission({
    permissionId: 177,
    permissionSelector: Permissions.CanRevertPaymentReserveChanges,
    permissions: [Permissions.CanRevertPaymentReserveChanges]
  }),

  CanCreateProjects: createPermission({
    permissionId: 180,
    permissionSelector: Permissions.CanCreateProjects,
    permissions: [Permissions.CanCreateProjects]
  }),
  CanViewProjects: createPermission({
    permissionId: 181,
    permissionSelector: Permissions.CanViewProjects,
    permissions: [Permissions.CanViewProjects]
  }),
  CanEditProjects: createPermission({
    permissionId: 182,
    permissionSelector: Permissions.CanEditProjects,
    permissions: [Permissions.CanEditProjects]
  }),
  CanDeleteProjects: createPermission({
    permissionId: 183,
    permissionSelector: Permissions.CanDeleteProjects,
    permissions: [Permissions.CanDeleteProjects]
  }),

  CanCreateProjectCommissions: createPermission({
    permissionId: 190,
    permissionSelector: Permissions.CanCreateProjectCommissions,
    permissions: [Permissions.CanCreateProjectCommissions]
  }),
  CanViewProjectCommissions: createPermission({
    permissionId: 191,
    permissionSelector: Permissions.CanViewProjectCommissions,
    permissions: [Permissions.CanViewProjectCommissions]
  }),
  CanEditProjectCommissions: createPermission({
    permissionId: 192,
    permissionSelector: Permissions.CanEditProjectCommissions,
    permissions: [Permissions.CanEditProjectCommissions]
  }),
  CanDeleteProjectCommissions: createPermission({
    permissionId: 193,
    permissionSelector: Permissions.CanDeleteProjectCommissions,
    permissions: [Permissions.CanDeleteProjectCommissions]
  }),

  CanCreateProspects: createPermission({
    permissionId: 195,
    permissionSelector: Permissions.CanCreateProspects,
    permissions: [Permissions.CanCreateProspects]
  }),
  CanViewProspects: createPermission({
    permissionId: 196,
    permissionSelector: Permissions.CanViewProspects,
    permissions: [Permissions.CanViewProspects]
  }),
  CanEditProspects: createPermission({
    permissionId: 197,
    permissionSelector: Permissions.CanEditProspects,
    permissions: [Permissions.CanEditProspects]
  }),
  CanConvertProspects: createPermission({
    permissionId: 198,
    permissionSelector: Permissions.CanConvertProspects,
    permissions: [Permissions.CanConvertProspects]
  }),
  CanManageProspectActivities: createPermission({
    permissionId: 199,
    permissionSelector: Permissions.CanManageProspectActivities,
    permissions: [Permissions.CanManageProspectActivities]
  }),

  CanCreateQuotations: createPermission({
    permissionId: 200,
    permissionSelector: Permissions.CanCreateQuotations,
    permissions: [Permissions.CanCreateQuotations]
  }),
  CanViewQuotations: createPermission({
    permissionId: 201,
    permissionSelector: Permissions.CanViewQuotations,
    permissions: [Permissions.CanViewQuotations]
  }),
  CanEditQuotations: createPermission({
    permissionId: 202,
    permissionSelector: Permissions.CanEditQuotations,
    permissions: [Permissions.CanEditQuotations]
  }),
  CanCancelQuotations: createPermission({
    permissionId: 203,
    permissionSelector: Permissions.CanCancelQuotations,
    permissions: [Permissions.CanCancelQuotations]
  }),
  CanRequestQuotationCancellations: createPermission({
    permissionId: 204,
    permissionSelector: Permissions.CanRequestQuotationCancellations,
    permissions: [Permissions.CanRequestQuotationCancellations]
  }),
  CanReviewQuotationCancellations: createPermission({
    permissionId: 205,
    permissionSelector: Permissions.CanReviewQuotationCancellations,
    permissions: [Permissions.CanReviewQuotationCancellations]
  }),
  CanRemoveQuotationProducts: createPermission({
    permissionId: 206,
    permissionSelector: Permissions.CanRemoveQuotationProducts,
    permissions: [Permissions.CanRemoveQuotationProducts]
  }),
  CanApproveDiscountQuatations: createPermission({
    permissionId: 207,
    permissionSelector: Permissions.CanApproveDiscountQuatations,
    permissions: [Permissions.CanApproveDiscountQuatations]
  }),

  CanCreateReasonsForRequest: createPermission({
    permissionId: 210,
    permissionSelector: Permissions.CanCreateReasonsForRequest,
    permissions: [Permissions.CanCreateReasonsForRequest]
  }),
  CanViewReasonsForRequest: createPermission({
    permissionId: 211,
    permissionSelector: Permissions.CanViewReasonsForRequest,
    permissions: [Permissions.CanViewReasonsForRequest]
  }),
  CanEditReasonsForRequest: createPermission({
    permissionId: 212,
    permissionSelector: Permissions.CanEditReasonsForRequest,
    permissions: [Permissions.CanEditReasonsForRequest]
  }),
  CanDeleteReasonsForRequest: createPermission({
    permissionId: 213,
    permissionSelector: Permissions.CanDeleteReasonsForRequest,
    permissions: [Permissions.CanDeleteReasonsForRequest]
  }),

  CanCreateRoles: createPermission({
    permissionId: 215,
    permissionSelector: Permissions.CanCreateRoles,
    permissions: [Permissions.CanCreateRoles]
  }),
  CanViewRoles: createPermission({
    permissionId: 216,
    permissionSelector: Permissions.CanViewRoles,
    permissions: [Permissions.CanViewRoles]
  }),
  CanEditRoles: createPermission({
    permissionId: 217,
    permissionSelector: Permissions.CanEditRoles,
    permissions: [Permissions.CanEditRoles]
  }),
  CanDeleteRoles: createPermission({
    permissionId: 218,
    permissionSelector: Permissions.CanDeleteRoles,
    permissions: [Permissions.CanDeleteRoles]
  }),

  CanCreateStatuses: createPermission({
    permissionId: 220,
    permissionSelector: Permissions.CanCreateStatuses,
    permissions: [Permissions.CanCreateStatuses]
  }),
  CanViewStatuses: createPermission({
    permissionId: 221,
    permissionSelector: Permissions.CanViewStatuses,
    permissions: [Permissions.CanViewStatuses]
  }),
  CanEditStatuses: createPermission({
    permissionId: 222,
    permissionSelector: Permissions.CanEditStatuses,
    permissions: [Permissions.CanEditStatuses]
  }),
  CanDeleteStatuses: createPermission({
    permissionId: 223,
    permissionSelector: Permissions.CanDeleteStatuses,
    permissions: [Permissions.CanDeleteStatuses]
  }),

  CanCreateSubcategories: createPermission({
    permissionId: 225,
    permissionSelector: Permissions.CanCreateSubcategories,
    permissions: [Permissions.CanCreateSubcategories]
  }),
  CanViewSubcategories: createPermission({
    permissionId: 226,
    permissionSelector: Permissions.CanViewSubcategories,
    permissions: [Permissions.CanViewSubcategories]
  }),
  CanEditSubcategories: createPermission({
    permissionId: 227,
    permissionSelector: Permissions.CanEditSubcategories,
    permissions: [Permissions.CanEditSubcategories]
  }),
  CanDeleteSubcategories: createPermission({
    permissionId: 228,
    permissionSelector: Permissions.CanDeleteSubcategories,
    permissions: [Permissions.CanDeleteSubcategories]
  }),

  CanCreateTypeActivities: createPermission({
    permissionId: 230,
    permissionSelector: Permissions.CanCreateTypeActivities,
    permissions: [Permissions.CanCreateTypeActivities]
  }),
  CanViewTypeActivities: createPermission({
    permissionId: 231,
    permissionSelector: Permissions.CanViewTypeActivities,
    permissions: [Permissions.CanViewTypeActivities]
  }),
  CanEditTypeActivities: createPermission({
    permissionId: 232,
    permissionSelector: Permissions.CanEditTypeActivities,
    permissions: [Permissions.CanEditTypeActivities]
  }),
  CanDeleteTypeActivities: createPermission({
    permissionId: 233,
    permissionSelector: Permissions.CanDeleteTypeActivities,
    permissions: [Permissions.CanDeleteTypeActivities]
  }),

  CanCreateTypeActivityModule: createPermission({
    permissionId: 830,
    permissionSelector: Permissions.CanCreateTypeActivityModule,
    permissions: [Permissions.CanCreateTypeActivityModule]
  }),
  CanViewTypeActivityModule: createPermission({
    permissionId: 831,
    permissionSelector: Permissions.CanViewTypeActivityModule,
    permissions: [Permissions.CanViewTypeActivityModule]
  }),
  CanEditTypeActivityModule: createPermission({
    permissionId: 832,
    permissionSelector: Permissions.CanEditTypeActivityModule,
    permissions: [Permissions.CanEditTypeActivityModule]
  }),
  CanDeleteTypeActivityModule: createPermission({
    permissionId: 833,
    permissionSelector: Permissions.CanDeleteTypeActivityModule,
    permissions: [Permissions.CanDeleteTypeActivityModule]
  }),

  CanCreateProspectActivity: createPermission({
    permissionId: 810,
    permissionSelector: Permissions.CanCreateProspectActivity,
    permissions: [Permissions.CanCreateProspectActivity]
  }),

  CanViewProspectActivity: createPermission({
    permissionId: 811,
    permissionSelector: Permissions.CanViewProspectActivity,
    permissions: [Permissions.CanViewProspectActivity]
  }),

  CanEditProspectActivity: createPermission({
    permissionId: 812,
    permissionSelector: Permissions.CanEditProspectActivity,
    permissions: [Permissions.CanEditProspectActivity]
  }),

  CanDeleteProspectActivity: createPermission({
    permissionId: 813,
    permissionSelector: Permissions.CanDeleteProspectActivity,
    permissions: [Permissions.CanDeleteProspectActivity]
  }),

  CanCreatePaymentOrderActivity: createPermission({
    permissionId: 820,
    permissionSelector: Permissions.CanCreatePaymentOrderActivity,
    permissions: [Permissions.CanCreatePaymentOrderActivity]
  }),

  CanViewPaymentOrderActivity: createPermission({
    permissionId: 821,
    permissionSelector: Permissions.CanViewPaymentOrderActivity,
    permissions: [Permissions.CanViewPaymentOrderActivity]
  }),

  CanEditPaymentOrderActivity: createPermission({
    permissionId: 822,
    permissionSelector: Permissions.CanEditPaymentOrderActivity,
    permissions: [Permissions.CanEditPaymentOrderActivity]
  }),

  CanDeletePaymentOrderActivity: createPermission({
    permissionId: 823,
    permissionSelector: Permissions.CanDeletePaymentOrderActivity,
    permissions: [Permissions.CanDeletePaymentOrderActivity]
  }),

  CanCreateEvaluations: createPermission({
    permissionId: 1100,
    permissionSelector: Permissions.CanCreateEvaluations,
    permissions: [Permissions.CanCreateEvaluations],
  }),
  CanViewEvaluations: createPermission({
    permissionId: 1101,
    permissionSelector: Permissions.CanViewEvaluations,
    permissions: [Permissions.CanViewEvaluations],
  }),
  CanEditEvaluations: createPermission({
    permissionId: 1102,
    permissionSelector: Permissions.CanEditEvaluations,
    permissions: [Permissions.CanEditEvaluations],
  }),
  CanCloseEvaluations: createPermission({
    permissionId: 1103,
    permissionSelector: Permissions.CanCloseEvaluations,
    permissions: [Permissions.CanCloseEvaluations],
  }),
  CanApproveEscalatedEvaluations: createPermission({
    permissionId: 1108,
    permissionSelector: Permissions.CanApproveEscalatedEvaluations,
    permissions: [Permissions.CanApproveEscalatedEvaluations],
  }),

  CanCreateEvaluationReasons: createPermission({
    permissionId: 1104,
    permissionSelector: Permissions.CanCreateEvaluationReasons,
    permissions: [Permissions.CanCreateEvaluationReasons],
  }),
  CanViewEvaluationReasons: createPermission({
    permissionId: 1105,
    permissionSelector: Permissions.CanViewEvaluationReasons,
    permissions: [Permissions.CanViewEvaluationReasons],
  }),
  CanEditEvaluationReasons: createPermission({
    permissionId: 1106,
    permissionSelector: Permissions.CanEditEvaluationReasons,
    permissions: [Permissions.CanEditEvaluationReasons],
  }),
  CanDeleteEvaluationReasons: createPermission({
    permissionId: 1107,
    permissionSelector: Permissions.CanDeleteEvaluationReasons,
    permissions: [Permissions.CanDeleteEvaluationReasons],
  }),

  CanCreatePepTypes: createPermission({
    permissionId: 1110,
    permissionSelector: Permissions.CanCreatePepTypes,
    permissions: [Permissions.CanCreatePepTypes],
  }),
  CanViewPepTypes: createPermission({
    permissionId: 1111,
    permissionSelector: Permissions.CanViewPepTypes,
    permissions: [Permissions.CanViewPepTypes],
  }),
  CanEditPepTypes: createPermission({
    permissionId: 1112,
    permissionSelector: Permissions.CanEditPepTypes,
    permissions: [Permissions.CanEditPepTypes],
  }),
  CanDeletePepTypes: createPermission({
    permissionId: 1113,
    permissionSelector: Permissions.CanDeletePepTypes,
    permissions: [Permissions.CanDeletePepTypes],
  }),
  CanViewUnqualifiedProspects: createPermission({
    permissionId: 1114,
    permissionSelector: Permissions.CanViewUnqualifiedProspects,
    permissions: [Permissions.CanViewUnqualifiedProspects],
  }),

  CanCreateTypeOrigins: createPermission({
    permissionId: 235,
    permissionSelector: Permissions.CanCreateTypeOrigins,
    permissions: [Permissions.CanCreateTypeOrigins]
  }),
  CanViewTypeOrigins: createPermission({
    permissionId: 236,
    permissionSelector: Permissions.CanViewTypeOrigins,
    permissions: [Permissions.CanViewTypeOrigins]
  }),
  CanEditTypeOrigins: createPermission({
    permissionId: 237,
    permissionSelector: Permissions.CanEditTypeOrigins,
    permissions: [Permissions.CanEditTypeOrigins]
  }),
  CanDeleteTypeOrigins: createPermission({
    permissionId: 238,
    permissionSelector: Permissions.CanDeleteTypeOrigins,
    permissions: [Permissions.CanDeleteTypeOrigins]
  }),

  CanCreateTypeStatuses: createPermission({
    permissionId: 240,
    permissionSelector: Permissions.CanCreateTypeStatuses,
    permissions: [Permissions.CanCreateTypeStatuses]
  }),
  CanViewTypeStatuses: createPermission({
    permissionId: 241,
    permissionSelector: Permissions.CanViewTypeStatuses,
    permissions: [Permissions.CanViewTypeStatuses]
  }),
  CanEditTypeStatuses: createPermission({
    permissionId: 242,
    permissionSelector: Permissions.CanEditTypeStatuses,
    permissions: [Permissions.CanEditTypeStatuses]
  }),
  CanDeleteTypeStatuses: createPermission({
    permissionId: 243,
    permissionSelector: Permissions.CanDeleteTypeStatuses,
    permissions: [Permissions.CanDeleteTypeStatuses]
  }),

  CanCreateUnitOfMeasurements: createPermission({
    permissionId: 245,
    permissionSelector: Permissions.CanCreateUnitOfMeasurements,
    permissions: [Permissions.CanCreateUnitOfMeasurements]
  }),
  CanViewUnitOfMeasurements: createPermission({
    permissionId: 246,
    permissionSelector: Permissions.CanViewUnitOfMeasurements,
    permissions: [Permissions.CanViewUnitOfMeasurements]
  }),
  CanEditUnitOfMeasurements: createPermission({
    permissionId: 247,
    permissionSelector: Permissions.CanEditUnitOfMeasurements,
    permissions: [Permissions.CanEditUnitOfMeasurements]
  }),
  CanDeleteUnitOfMeasurements: createPermission({
    permissionId: 248,
    permissionSelector: Permissions.CanDeleteUnitOfMeasurements,
    permissions: [Permissions.CanDeleteUnitOfMeasurements]
  }),

  CanCreateUsers: createPermission({
    permissionId: 250,
    permissionSelector: Permissions.CanCreateUsers,
    permissions: [Permissions.CanCreateUsers]
  }),
  CanViewUsers: createPermission({
    permissionId: 251,
    permissionSelector: Permissions.CanViewUsers,
    permissions: [Permissions.CanViewUsers]
  }),
  CanEditUsers: createPermission({
    permissionId: 252,
    permissionSelector: Permissions.CanEditUsers,
    permissions: [Permissions.CanEditUsers]
  }),
  CanDeleteUsers: createPermission({
    permissionId: 253,
    permissionSelector: Permissions.CanDeleteUsers,
    permissions: [Permissions.CanDeleteUsers]
  }),
  CanCreateUserBrokers: createPermission({
    permissionId: 254,
    permissionSelector: Permissions.CanCreateUserBrokers,
    permissions: [Permissions.CanCreateUserBrokers]
  }),

  CanCreateUserCommissions: createPermission({
    permissionId: 260,
    permissionSelector: Permissions.CanCreateUserCommissions,
    permissions: [Permissions.CanCreateUserCommissions]
  }),
  CanRemoveUserCommissions: createPermission({
    permissionId: 261,
    permissionSelector: Permissions.CanRemoveUserCommissions,
    permissions: [Permissions.CanRemoveUserCommissions]
  }),
  CanCancelProductCommissions: createPermission({
    permissionId: 262,
    permissionSelector: Permissions.CanCancelProductCommissions,
    permissions: [Permissions.CanCancelProductCommissions]
  }),
  CanEditUserCommissions: createPermission({
    permissionId: 263,
    permissionSelector: Permissions.CanEditUserCommissions,
    permissions: [Permissions.CanEditUserCommissions]
  }),
  CanViewUserCommissions: createPermission({
    permissionId: 264,
    permissionSelector: Permissions.CanViewUserCommissions,
    permissions: [Permissions.CanViewUserCommissions]
  }),

  CanCreateWinReasons: createPermission({
    permissionId: 270,
    permissionSelector: Permissions.CanCreateWinReasons,
    permissions: [Permissions.CanCreateWinReasons]
  }),
  CanViewWinReasons: createPermission({
    permissionId: 271,
    permissionSelector: Permissions.CanViewWinReasons,
    permissions: [Permissions.CanViewWinReasons]
  }),
  CanEditWinReasons: createPermission({
    permissionId: 272,
    permissionSelector: Permissions.CanEditWinReasons,
    permissions: [Permissions.CanEditWinReasons]
  }),
  CanDeleteWinReasons: createPermission({
    permissionId: 273,
    permissionSelector: Permissions.CanDeleteWinReasons,
    permissions: [Permissions.CanDeleteWinReasons]
  }),

  CanCreateLossReasons: createPermission({
    permissionId: 280,
    permissionSelector: Permissions.CanCreateLossReasons,
    permissions: [Permissions.CanCreateLossReasons]
  }),
  CanViewLossReasons: createPermission({
    permissionId: 281,
    permissionSelector: Permissions.CanViewLossReasons,
    permissions: [Permissions.CanViewLossReasons]
  }),
  CanEditLossReasons: createPermission({
    permissionId: 282,
    permissionSelector: Permissions.CanEditLossReasons,
    permissions: [Permissions.CanEditLossReasons]
  }),
  CanDeleteLossReasons: createPermission({
    permissionId: 283,
    permissionSelector: Permissions.CanDeleteLossReasons,
    permissions: [Permissions.CanDeleteLossReasons]
  }),

  CanViewBreakEvenPointKpi: createPermission({
    permissionId: 400,
    permissionSelector: Permissions.CanViewBreakEvenPointKpi,
    permissions: [Permissions.CanViewBreakEvenPointKpi]
  }),
  CanViewPendingPremiumAmountReceivableSummaryKpi: createPermission({
    permissionId: 401,
    permissionSelector:
      Permissions.CanViewPendingPremiumAmountReceivableSummaryKpi,
    permissions: [Permissions.CanViewPendingPremiumAmountReceivableSummaryKpi]
  }),
  CanViewProjectAreaSummaryKpi: createPermission({
    permissionId: 402,
    permissionSelector: Permissions.CanViewProjectAreaSummaryKpi,
    permissions: [Permissions.CanViewProjectAreaSummaryKpi]
  }),
  CanViewProjectAreaSalePriceSummaryKpi: createPermission({
    permissionId: 403,
    permissionSelector: Permissions.CanViewProjectAreaSalePriceSummaryKpi,
    permissions: [Permissions.CanViewProjectAreaSalePriceSummaryKpi]
  }),
  CanViewProjectIncomeSummaryKpi: createPermission({
    permissionId: 404,
    permissionSelector: Permissions.CanViewProjectIncomeSummaryKpi,
    permissions: [Permissions.CanViewProjectIncomeSummaryKpi]
  }),
  CanViewProjectReservedIncomeSummaryKpi: createPermission({
    permissionId: 405,
    permissionSelector: Permissions.CanViewProjectReservedIncomeSummaryKpi,
    permissions: [Permissions.CanViewProjectReservedIncomeSummaryKpi]
  }),
  CanViewProjectSubcategoriesSummaryKpi: createPermission({
    permissionId: 406,
    permissionSelector: Permissions.CanViewProjectSubcategoriesSummaryKpi,
    permissions: [Permissions.CanViewProjectSubcategoriesSummaryKpi]
  }),
  CanViewTotalCommissionKpis: createPermission({
    permissionId: 407,
    permissionSelector: Permissions.CanViewTotalCommissionKpis,
    permissions: [Permissions.CanViewTotalCommissionKpis]
  }),
  CanViewAdvisorKpis: createPermission({
    permissionId: 408,
    permissionSelector: Permissions.CanViewAdvisorKpis,
    permissions: [Permissions.CanViewAdvisorKpis]
  }),
  CanViewOpportunitiesKpis: createPermission({
    permissionId: 409,
    permissionSelector: Permissions.CanViewOpportunitiesKpis,
    permissions: [Permissions.CanViewOpportunitiesKpis]
  }),
  CanViewSalesPerMonthKpi: createPermission({
    permissionId: 410,
    permissionSelector: Permissions.CanViewSalesPerMonthKpi,
    permissions: [Permissions.CanViewSalesPerMonthKpi]
  }),
  CanViewLeadsKpis: createPermission({
    permissionId: 411,
    permissionSelector: Permissions.CanViewLeadsKpis,
    permissions: [Permissions.CanViewLeadsKpis]
  }),
  CanViewMarketingDashboard: createPermission({
    permissionId: 1115,
    permissionSelector: Permissions.CanViewMarketingDashboard,
    permissions: [Permissions.CanViewMarketingDashboard]
  }),
  CanViewGeneralLeadsReport: createPermission({
    permissionId: 1116,
    permissionSelector: Permissions.CanViewGeneralLeadsReport,
    permissions: [Permissions.CanViewGeneralLeadsReport]
  }),
  CanViewProductStatusKpis: createPermission({
    permissionId: 412,
    permissionSelector: Permissions.CanViewProductStatusKpis,
    permissions: [Permissions.CanViewProductStatusKpis]
  }),
  CanViewTotalComparativeKpis: createPermission({
    permissionId: 413,
    permissionSelector: Permissions.CanViewTotalComparativeKpis,
    permissions: [Permissions.CanViewTotalComparativeKpis]
  }),
  CanViewPaymentRequestKpi: createPermission({
    permissionId: 414,
    permissionSelector: Permissions.CanViewPaymentRequestKpi,
    permissions: [Permissions.CanViewPaymentRequestKpi]
  }),
  CanViewClientsPerProjectKpi: createPermission({
    permissionId: 415,
    permissionSelector: Permissions.CanViewClientsPerProjectKpi,
    permissions: [Permissions.CanViewClientsPerProjectKpi]
  }),
  CanViewAdvisorGoalKpi: createPermission({
    permissionId: 416,
    permissionSelector: Permissions.CanViewAdvisorGoalKpi,
    permissions: [Permissions.CanViewAdvisorGoalKpi]
  }),
  CanViewAllKpis: createPermission({
    permissionId: 499,
    permissionSelector: Permissions.CanViewAllKpis,
    permissions: [Permissions.CanViewAllKpis]
  }),

  CanViewTopQuoteProductReport: createPermission({
    permissionId: 500,
    permissionSelector: Permissions.CanViewTopQuoteProductReport,
    permissions: [Permissions.CanViewTopQuoteProductReport]
  }),
  CanViewProductsByProjectReport: createPermission({
    permissionId: 501,
    permissionSelector: Permissions.CanViewProductsByProjectReport,
    permissions: [Permissions.CanViewProductsByProjectReport]
  }),
  CanViewAvailableProductsReport: createPermission({
    permissionId: 502,
    permissionSelector: Permissions.CanViewAvailableProductsReport,
    permissions: [Permissions.CanViewAvailableProductsReport]
  }),
  CanViewTopSoldProductReport: createPermission({
    permissionId: 503,
    permissionSelector: Permissions.CanViewTopSoldProductReport,
    permissions: [Permissions.CanViewTopSoldProductReport]
  }),
  CanViewAdvisorActivitiesReport: createPermission({
    permissionId: 504,
    permissionSelector: Permissions.CanViewAdvisorActivitiesReport,
    permissions: [Permissions.CanViewAdvisorActivitiesReport]
  }),
  CanViewOpportunityOriginsReport: createPermission({
    permissionId: 505,
    permissionSelector: Permissions.CanViewOpportunityOriginsReport,
    permissions: [Permissions.CanViewOpportunityOriginsReport]
  }),
  CanViewPaymentHistoryReport: createPermission({
    permissionId: 506,
    permissionSelector: Permissions.CanViewPaymentHistoryReport,
    permissions: [Permissions.CanViewPaymentHistoryReport]
  }),
  CanViewPaymentReservesHistoryReport: createPermission({
    permissionId: 507,
    permissionSelector: Permissions.CanViewPaymentReservesHistoryReport,
    permissions: [Permissions.CanViewPaymentReservesHistoryReport]
  }),
  CanViewMasterOpportunityReport: createPermission({
    permissionId: 508,
    permissionSelector: Permissions.CanViewMasterOpportunityReport,
    permissions: [Permissions.CanViewMasterOpportunityReport]
  }),
  CanViewMasterProspectReport: createPermission({
    permissionId: 509,
    permissionSelector: Permissions.CanViewMasterProspectReport,
    permissions: [Permissions.CanViewMasterProspectReport]
  }),
  CanViewAdvisorGoalReport: createPermission({
    permissionId: 510,
    permissionSelector: Permissions.CanViewAdvisorGoalReport,
    permissions: [Permissions.CanViewAdvisorGoalReport]
  }),
  CanViewClientQuoteReport: createPermission({
    permissionId: 511,
    permissionSelector: Permissions.CanViewClientQuoteReport,
    permissions: [Permissions.CanViewClientQuoteReport]
  }),
  CanViewClientByProductReport: createPermission({
    permissionId: 512,
    permissionSelector: Permissions.CanViewClientByProductReport,
    permissions: [Permissions.CanViewClientByProductReport]
  }),
  CanViewUnificatePaymentOrderReport: createPermission({
    permissionId: 513,
    permissionSelector: Permissions.CanViewUnificatePaymentOrderReport,
    permissions: [Permissions.CanViewUnificatePaymentOrderReport]
  }),
  CanViewCustomerWalletReport: createPermission({
    permissionId: 514,
    permissionSelector: Permissions.CanViewCustomerWalletReport,
    permissions: [Permissions.CanViewCustomerWalletReport]
  }),
  CanViewAdvisorPaymentStatusReport: createPermission({
    permissionId: 515,
    permissionSelector: Permissions.CanViewAdvisorPaymentStatusReport,
    permissions: [Permissions.CanViewAdvisorPaymentStatusReport]
  }),
  CanViewCustomerPaymentStatusReport: createPermission({
    permissionId: 516,
    permissionSelector: Permissions.CanViewCustomerPaymentStatusReport,
    permissions: [Permissions.CanViewCustomerPaymentStatusReport]
  }),
  CanViewOldBalancesReport: createPermission({
    permissionId: 517,
    permissionSelector: Permissions.CanViewOldBalancesReport,
    permissions: [Permissions.CanViewOldBalancesReport]
  }),
  CanViewPendingWithdrawalReport: createPermission({
    permissionId: 518,
    permissionSelector: Permissions.CanViewPendingWithdrawalReport,
    permissions: [Permissions.CanViewPendingWithdrawalReport]
  }),
  CanViewWithdrawalRequestsApprovedReport: createPermission({
    permissionId: 536,
    permissionSelector: Permissions.CanViewWithdrawalRequestsApprovedReport,
    permissions: [Permissions.CanViewWithdrawalRequestsApprovedReport],
  }),
  CanViewPaidCommissionPerMonthReport: createPermission({
    permissionId: 519,
    permissionSelector: Permissions.CanViewPaidCommissionPerMonthReport,
    permissions: [Permissions.CanViewPaidCommissionPerMonthReport]
  }),
  CanViewPendingPaymentCommissionReport: createPermission({
    permissionId: 520,
    permissionSelector: Permissions.CanViewPendingPaymentCommissionReport,
    permissions: [Permissions.CanViewPendingPaymentCommissionReport]
  }),
  CanViewCommissionsPerProjectReport: createPermission({
    permissionId: 521,
    permissionSelector: Permissions.CanViewCommissionsPerProjectReport,
    permissions: [Permissions.CanViewCommissionsPerProjectReport]
  }),
  CanViewCustomerInfoReport: createPermission({
    permissionId: 522,
    permissionSelector: Permissions.CanViewCustomerInfoReport,
    permissions: [Permissions.CanViewCustomerInfoReport]
  }),
  CanViewAccountsReceivableReport: createPermission({
    permissionId: 537,
    permissionSelector: Permissions.CanViewAccountsReceivableReport,
    permissions: [Permissions.CanViewAccountsReceivableReport],
  }),
  CanViewCustomersHistoryReport: createPermission({
    permissionId: 523,
    permissionSelector: Permissions.CanViewCustomersHistoryReport,
    permissions: [Permissions.CanViewCustomersHistoryReport]
  }),
  CanViewDocumentationComplianceReport: createPermission({
    permissionId: 524,
    permissionSelector: Permissions.CanViewDocumentationComplianceReport,
    permissions: [Permissions.CanViewDocumentationComplianceReport]
  }),
  CanViewCommissionsAvailableForPaymentReport: createPermission({
    permissionId: 525,
    permissionSelector: Permissions.CanViewCommissionsAvailableForPaymentReport,
    permissions: [Permissions.CanViewCommissionsAvailableForPaymentReport]
  }),
  CanViewPendingPremiumAmountReceivableReport: createPermission({
    permissionId: 530,
    permissionSelector: Permissions.CanViewPendingPremiumAmountReceivableReport,
    permissions: [Permissions.CanViewPendingPremiumAmountReceivableReport]
  }),
  CanViewProjectTotalReservedIncomeDetailReport: createPermission({
    permissionId: 531,
    permissionSelector:
      Permissions.CanViewProjectTotalReservedIncomeDetailReport,
    permissions: [Permissions.CanViewProjectTotalReservedIncomeDetailReport]
  }),
  CanViewProjectTotalReservedIncomePaymentDetailReport: createPermission({
    permissionId: 532,
    permissionSelector:
      Permissions.CanViewProjectTotalReservedIncomePaymentDetailReport,
    permissions: [
      Permissions.CanViewProjectTotalReservedIncomePaymentDetailReport
    ]
  }),
  CanViewProductReservesDetailReport: createPermission({
    permissionId: 533,
    permissionSelector: Permissions.CanViewProductReservesDetailReport,
    permissions: [Permissions.CanViewProductReservesDetailReport]
  }),
  CanViewPaymentOrdersFeesDetailReport: createPermission({
    permissionId: 534,
    permissionSelector: Permissions.CanViewPaymentOrdersFeesDetailReport,
    permissions: [Permissions.CanViewPaymentOrdersFeesDetailReport]
  }),
  CanViewProductDatasheetReport: createPermission({
    permissionId: 535,
    permissionSelector: Permissions.CanViewProductDatasheetReport,
    permissions: [Permissions.CanViewProductDatasheetReport]
  }),
  CanViewAllReports: createPermission({
    permissionId: 599,
    permissionSelector: Permissions.CanViewAllReports,
    permissions: [Permissions.CanViewAllReports]
  }),

  CanExecuteJobs: createPermission({
    permissionId: 700,
    permissionSelector: Permissions.CanExecuteJobs,
    permissions: [Permissions.CanExecuteJobs],
  }),

  CanCreateDiscardReasons: createPermission({
    permissionId: 800,
    permissionSelector: Permissions.CanCreateDiscardReasons,
    permissions: [Permissions.CanCreateDiscardReasons]
  }),
  CanViewDiscardReasons: createPermission({
    permissionId: 801,
    permissionSelector: Permissions.CanViewDiscardReasons,
    permissions: [Permissions.CanViewDiscardReasons]
  }),
  CanEditDiscardReasons: createPermission({
    permissionId: 802,
    permissionSelector: Permissions.CanEditDiscardReasons,
    permissions: [Permissions.CanEditDiscardReasons]
  }),
  CanDeleteDiscardReasons: createPermission({
    permissionId: 803,
    permissionSelector: Permissions.CanDeleteDiscardReasons,
    permissions: [Permissions.CanDeleteDiscardReasons]
  }),
  CanCreateTypeDocumentModule: createPermission({
    permissionId: 840,
    permissionSelector: Permissions.CanCreateTypeDocumentModule,
    permissions: [Permissions.CanCreateTypeDocumentModule],
  }),
  CanViewTypeDocumentModule: createPermission({
    permissionId: 841,
    permissionSelector: Permissions.CanViewTypeDocumentModule,
    permissions: [Permissions.CanViewTypeDocumentModule],
  }),
  CanEditTypeDocumentModule: createPermission({
    permissionId: 842,
    permissionSelector: Permissions.CanEditTypeDocumentModule,
    permissions: [Permissions.CanEditTypeDocumentModule],
  }),
  CanDeleteTypeDocumentModule: createPermission({
    permissionId: 843,
    permissionSelector: Permissions.CanDeleteTypeDocumentModule,
    permissions: [Permissions.CanDeleteTypeDocumentModule],
  }),

  CanChangeApplyProductCommission: createPermission({
    permissionId: 850,
    permissionSelector: Permissions.CanChangeApplyProductCommission,
    permissions: [Permissions.CanChangeApplyProductCommission],
  }),
  CanReciveEmailCreateCommission: createPermission({
    permissionId: 851,
    permissionSelector: Permissions.CanReciveEmailCreateCommission,
    permissions: [Permissions.CanReciveEmailCreateCommission]
  }),
  CanReciveEmailPendingReviewCommission: createPermission({
    permissionId: 852,
    permissionSelector: Permissions.CanReciveEmailPendingReviewCommission,
    permissions: [Permissions.CanReciveEmailPendingReviewCommission]
  }),
  CanReciveEmailPendingReviewAccountingCommission: createPermission({
    permissionId: 853,
    permissionSelector:
      Permissions.CanReciveEmailPendingReviewAccountingCommission,
    permissions: [Permissions.CanReciveEmailPendingReviewAccountingCommission]
  }),
  CanReciveEmailSignatureSaleAdvisorCommission: createPermission({
    permissionId: 854,
    permissionSelector:
      Permissions.CanReciveEmailSignatureSaleAdvisorCommission,
    permissions: [Permissions.CanReciveEmailSignatureSaleAdvisorCommission]
  }),
  CanReciveEmailSignatureSaleAdvisorApproveCommission: createPermission({
    permissionId: 855,
    permissionSelector:
      Permissions.CanReciveEmailSignatureSaleAdvisorApproveCommission,
    permissions: [
      Permissions.CanReciveEmailSignatureSaleAdvisorApproveCommission
    ]
  }),
  CanReciveEmailCheckAccountingCommission: createPermission({
    permissionId: 856,
    permissionSelector: Permissions.CanReciveEmailCheckAccountingCommission,
    permissions: [Permissions.CanReciveEmailCheckAccountingCommission]
  }),
  CanReciveEmailApplyPaymentAccountingCommission: createPermission({
    permissionId: 857,
    permissionSelector:
      Permissions.CanReciveEmailApplyPaymentAccountingCommission,
    permissions: [Permissions.CanReciveEmailApplyPaymentAccountingCommission]
  }),

  CanRequestPenaltyPaymentCommissions: createPermission({
    permissionId: 900,
    permissionSelector: Permissions.CanRequestPenaltyPaymentCommissions,
    permissions: [Permissions.CanRequestPenaltyPaymentCommissions]
  }),
  CanReceiveEmailPenaltyCommission: createPermission({
    permissionId: 901,
    permissionSelector: Permissions.CanReceiveEmailPenaltyCommission,
    permissions: [Permissions.CanReceiveEmailPenaltyCommission]
  }),
  CanViewRequestPenaltyPaymentCommissions: createPermission({
    permissionId: 902,
    permissionSelector: Permissions.CanViewRequestPenaltyPaymentCommissions,
    permissions: [Permissions.CanViewRequestPenaltyPaymentCommissions]
  }),
  CanCancelRequestPenaltyPaymentCommissions: createPermission({
    permissionId: 903,
    permissionSelector: Permissions.CanCancelRequestPenaltyPaymentCommissions,
    permissions: [Permissions.CanCancelRequestPenaltyPaymentCommissions]
  }),
  CanApproveRequestPenaltyPaymentCommissions: createPermission({
    permissionId: 904,
    permissionSelector: Permissions.CanApproveRequestPenaltyPaymentCommissions,
    permissions: [Permissions.CanApproveRequestPenaltyPaymentCommissions]
  }),

  CanCreateAdvisorGroup: createPermission({
    permissionId: 1120,
    permissionSelector: Permissions.CanCreateAdvisorGroup,
    permissions: [Permissions.CanCreateAdvisorGroup]
  }),
  CanViewAdvisorGroup: createPermission({
    permissionId: 1121,
    permissionSelector: Permissions.CanViewAdvisorGroup,
    permissions: [Permissions.CanViewAdvisorGroup]
  }),
  CanEditAdvisorGroup: createPermission({
    permissionId: 1122,
    permissionSelector: Permissions.CanEditAdvisorGroup,
    permissions: [Permissions.CanEditAdvisorGroup]
  }),
  CanDeleteAdvisorGroup: createPermission({
    permissionId: 1123,
    permissionSelector: Permissions.CanDeleteAdvisorGroup,
    permissions: [Permissions.CanDeleteAdvisorGroup]
  }),

  CanViewGoalKpi: createPermission({
    permissionId: 418,
    permissionSelector: Permissions.CanViewGoalKpi,
    permissions: [Permissions.CanViewGoalKpi]
  }),
  CanCreateGoal: createPermission({
    permissionId: 960,
    permissionSelector: Permissions.CanCreateGoal,
    permissions: [Permissions.CanCreateGoal]
  }),
  CanViewGoal: createPermission({
    permissionId: 961,
    permissionSelector: Permissions.CanViewGoal,
    permissions: [Permissions.CanViewGoal]
  }),
  CanEditGoal: createPermission({
    permissionId: 962,
    permissionSelector: Permissions.CanEditGoal,
    permissions: [Permissions.CanEditGoal]
  }),
  CanDeleteGoal: createPermission({
    permissionId: 963,
    permissionSelector: Permissions.CanDeleteGoal,
    permissions: [Permissions.CanDeleteGoal]
  }),
  CanCreateGoalMetric: createPermission({
    permissionId: 970,
    permissionSelector: Permissions.CanCreateGoalMetric,
    permissions: [Permissions.CanCreateGoalMetric]
  }),
  CanViewGoalMetric: createPermission({
    permissionId: 971,
    permissionSelector: Permissions.CanViewGoalMetric,
    permissions: [Permissions.CanViewGoalMetric]
  }),
  CanEditGoalMetric: createPermission({
    permissionId: 972,
    permissionSelector: Permissions.CanEditGoalMetric,
    permissions: [Permissions.CanEditGoalMetric]
  }),
  CanDeleteGoalMetric: createPermission({
    permissionId: 973,
    permissionSelector: Permissions.CanDeleteGoalMetric,
    permissions: [Permissions.CanDeleteGoalMetric]
  }),

  CanCreateNotifications: createPermission({
    permissionId: 1000,
    permissionSelector: Permissions.CanCreateNotifications,
    permissions: [Permissions.CanCreateNotifications]
  }),
  CanViewNotifications: createPermission({
    permissionId: 1001,
    permissionSelector: Permissions.CanViewNotifications,
    permissions: [Permissions.CanViewNotifications]
  }),
  CanEditNotifications: createPermission({
    permissionId: 1002,
    permissionSelector: Permissions.CanEditNotifications,
    permissions: [Permissions.CanEditNotifications]
  }),
  CanDeleteNotifications: createPermission({
    permissionId: 1003,
    permissionSelector: Permissions.CanDeleteNotifications,
    permissions: [Permissions.CanDeleteNotifications]
  }),

  CanCreateProductDeliveries: createPermission({
    permissionId: 1010,
    permissionSelector: Permissions.CanCreateProductDeliveries,
    permissions: [Permissions.CanCreateProductDeliveries]
  }),
  CanViewProductDeliveries: createPermission({
    permissionId: 1011,
    permissionSelector: Permissions.CanViewProductDeliveries,
    permissions: [Permissions.CanViewProductDeliveries]
  }),
  CanReviewProductDeliveryFinancingProcesses: createPermission({
    permissionId: 1012,
    permissionSelector: Permissions.CanReviewProductDeliveryFinancingProcesses,
    permissions: [Permissions.CanReviewProductDeliveryFinancingProcesses]
  }),
  CanReviewProductDeliveryLegalProcess: createPermission({
    permissionId: 1013,
    permissionSelector: Permissions.CanReviewProductDeliveryLegalProcess,
    permissions: [Permissions.CanReviewProductDeliveryLegalProcess]
  }),
  CanManageProductDeliveryProtocolSign: createPermission({
    permissionId: 1014,
    permissionSelector: Permissions.CanManageProductDeliveryProtocolSign,
    permissions: [Permissions.CanManageProductDeliveryProtocolSign]
  }),
  CanManageProductDeliveryDisbursements: createPermission({
    permissionId: 1015,
    permissionSelector: Permissions.CanManageProductDeliveryDisbursements,
    permissions: [Permissions.CanManageProductDeliveryDisbursements]
  }),
  CanCancelProductDeliveries: createPermission({
    permissionId: 1016,
    permissionSelector: Permissions.CanCancelProductDeliveries,
    permissions: [Permissions.CanCancelProductDeliveries]
  }),
  CanManageProductDeliveryDocuments: createPermission({
    permissionId: 1017,
    permissionSelector: Permissions.CanManageProductDeliveryDocuments,
    permissions: [Permissions.CanManageProductDeliveryDocuments]
  }),
  CanMoveProductDeliveriesThroughTransitionalSteps: createPermission({
    permissionId: 1018,
    permissionSelector:
      Permissions.CanMoveProductDeliveriesThroughTransitionalSteps,
    permissions: [Permissions.CanMoveProductDeliveriesThroughTransitionalSteps]
  }),

  CanModifyFinalizedProductDeliveries: createPermission({
    permissionId: 1020,
    permissionSelector: Permissions.CanModifyFinalizedProductDeliveries,
    permissions: [Permissions.CanModifyFinalizedProductDeliveries]
  }),

  CanRequestOverdueCondone: createPermission({
    permissionId: 1030,
    permissionSelector: Permissions.CanRequestOverdueCondone,
    permissions: [Permissions.CanRequestOverdueCondone]
  }),

  CanApproveOverdueCondone: createPermission({
    permissionId: 1031,
    permissionSelector: Permissions.CanApproveOverdueCondone,
    permissions: [Permissions.CanApproveOverdueCondone]
  }),

  CanApplyPaymentOrderDiscount: createPermission({
    permissionId: 1032,
    permissionSelector: Permissions.CanApplyPaymentOrderDiscount,
    permissions: [Permissions.CanApplyPaymentOrderDiscount]
  }),

  CanApprovePaymentOrderDiscount: createPermission({
    permissionId: 1033,
    permissionSelector: Permissions.CanApprovePaymentOrderDiscount,
    permissions: [Permissions.CanApprovePaymentOrderDiscount]
  }),

  CanAdditionalPaymentOrderFee: createPermission({
    permissionId: 1034,
    permissionSelector: Permissions.CanAdditionalPaymentOrderFee,
    permissions: [Permissions.CanAdditionalPaymentOrderFee]
  }),

  CanSyncPaymentOrderInvoice: createPermission({
    permissionId: 1067,
    permissionSelector: Permissions.CanSyncPaymentOrderInvoice,
    permissions: [Permissions.CanSyncPaymentOrderInvoice]
  }),

  CanCreateDiscountTypes: createPermission({
    permissionId: 1040,
    permissionSelector: Permissions.CanCreateDiscountTypes,
    permissions: [Permissions.CanCreateDiscountTypes]
  }),

  CanEditDiscountTypes: createPermission({
    permissionId: 1041,
    permissionSelector: Permissions.CanEditDiscountTypes,
    permissions: [Permissions.CanEditDiscountTypes]
  }),

  CanViewDiscountTypes: createPermission({
    permissionId: 1042,
    permissionSelector: Permissions.CanViewDiscountTypes,
    permissions: [Permissions.CanViewDiscountTypes]
  }),

  CanDeleteDiscountTypes: createPermission({
    permissionId: 1043,
    permissionSelector: Permissions.CanDeleteDiscountTypes,
    permissions: [Permissions.CanDeleteDiscountTypes]
  }),

  CanViewExchangeRates: createPermission({
    permissionId: 1050,
    permissionSelector: Permissions.CanViewExchangeRates,
    permissions: [Permissions.CanViewExchangeRates],
  }),
  
  CanCreateExchangeRates: createPermission({
    permissionId: 1051,
    permissionSelector: Permissions.CanCreateExchangeRates,
    permissions: [Permissions.CanCreateExchangeRates],
  }),

  CanEditExchangeRates: createPermission({
    permissionId: 1052,
    permissionSelector: Permissions.CanEditExchangeRates,
    permissions: [Permissions.CanEditExchangeRates],
  }),

  CanRunExchangeRateSync: createPermission({
    permissionId: 1053,
    permissionSelector: Permissions.CanRunExchangeRateSync,
    permissions: [Permissions.CanRunExchangeRateSync],
  }),

  CanCreateProspectStatus: createPermission({
    permissionId: 1060,
    permissionSelector: Permissions.CanCreateProspectStatus,
    permissions: [Permissions.CanCreateProspectStatus],
  }),
  CanViewProspectStatus: createPermission({
    permissionId: 1061,
    permissionSelector: Permissions.CanViewProspectStatus,
    permissions: [Permissions.CanViewProspectStatus],
  }),
  CanEditProspectStatus: createPermission({
    permissionId: 1062,
    permissionSelector: Permissions.CanEditProspectStatus,
    permissions: [Permissions.CanEditProspectStatus],
  }),
  CanDeleteProspectStatus: createPermission({
    permissionId: 1063,
    permissionSelector: Permissions.CanDeleteProspectStatus,
    permissions: [Permissions.CanDeleteProspectStatus],
  }),
  CanCreateProspectStepStatus: createPermission({
    permissionId: 1064,
    permissionSelector: Permissions.CanCreateProspectStepStatus,
    permissions: [Permissions.CanCreateProspectStepStatus],
  }),
  CanViewProspectStepStatus: createPermission({
    permissionId: 1065,
    permissionSelector: Permissions.CanViewProspectStepStatus,
    permissions: [Permissions.CanViewProspectStepStatus],
  }),
  CanUpdateProspectStepStatus: createPermission({
    permissionId: 1066,
    permissionSelector: Permissions.CanUpdateProspectStepStatus,
    permissions: [Permissions.CanUpdateProspectStepStatus],
  }),

  CanViewOpportunityStepTransitionTimeReport: createPermission({
    permissionId: 538,
    permissionSelector: Permissions.CanViewOpportunityStepTransitionTimeReport,
    permissions: [Permissions.CanViewOpportunityStepTransitionTimeReport],
  }),

  CanConfigureOpportunityStageGoals: createPermission({
    permissionId: 940,
    permissionSelector: Permissions.CanConfigureOpportunityStageGoals,
    permissions: [Permissions.CanConfigureOpportunityStageGoals],
  }),

  CanEditOpportunityStageGoalTargets: createPermission({
    permissionId: 941,
    permissionSelector: Permissions.CanEditOpportunityStageGoalTargets,
    permissions: [Permissions.CanEditOpportunityStageGoalTargets],
  }),

  CanViewOwnGoalCommissions: createPermission({
    permissionId: 1070,
    permissionSelector: Permissions.CanViewOwnGoalCommissions,
    permissions: [Permissions.CanViewOwnGoalCommissions],
  }),

  CanViewGoalCommissions: createPermission({
    permissionId: 1071,
    permissionSelector: Permissions.CanViewGoalCommissions,
    permissions: [Permissions.CanViewGoalCommissions],
  }),

  CanReviewGoalCommissionItems: createPermission({
    permissionId: 1072,
    permissionSelector: Permissions.CanReviewGoalCommissionItems,
    permissions: [Permissions.CanReviewGoalCommissionItems],
  }),

  CanProposeGoalCommissionPayments: createPermission({
    permissionId: 1073,
    permissionSelector: Permissions.CanProposeGoalCommissionPayments,
    permissions: [Permissions.CanProposeGoalCommissionPayments],
  }),

  CanApproveGoalCommissionRequests: createPermission({
    permissionId: 1074,
    permissionSelector: Permissions.CanApproveGoalCommissionRequests,
    permissions: [Permissions.CanApproveGoalCommissionRequests],
  }),

  CanResolveGoalCommissionIncidents: createPermission({
    permissionId: 1075,
    permissionSelector: Permissions.CanResolveGoalCommissionIncidents,
    permissions: [Permissions.CanResolveGoalCommissionIncidents],
  }),

  CanManageGoalCommissionSettings: createPermission({
    permissionId: 1076,
    permissionSelector: Permissions.CanManageGoalCommissionSettings,
    permissions: [Permissions.CanManageGoalCommissionSettings],
  }),
}

export const getUserPermissionMap = (params: {
  user: CheckPermissionUser
}): Record<keyof PermissionMap, boolean> => {
  const { user } = params

  return Object.keys(PERMISSIONS).reduce(
    (acc, key) => {
      const permission = PERMISSIONS[key as keyof PermissionMap]

      acc[key as keyof PermissionMap] = permission.hasPermission({
        user
      })

      return acc
    },
    {} as Record<keyof PermissionMap, boolean>
  )
}
